import { t, use } from "i18next";
import moment from "moment";

import { Card } from 'primereact/card';
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TabPanel, TabView } from 'primereact/tabview';
import PropTypes from 'prop-types';
import React from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from 'react-router-dom';
import BaseDetailsContainer from "../baseContainers/BaseDetailsContainer";
import ActionLink from "../components/ActionLink";
import { LocationAddressComponent } from "../components/LocationAddressComponent";
import DivContainer from "../components/DivContainer";
import YesNoDialog from "../components/YesNoDialog";
import InputAutocompleteComponent from "../components/inputs/InputAutocompleteComponent";
import InputCalendarComponent from "../components/inputs/InputCalendarComponent";
import InputCalendarRangeComponent from "../components/inputs/InputCalendarRangeComponent";
import InputDropdownComponent from "../components/inputs/InputDropdownComponent";
import InputMultiSelectComponent from "../components/inputs/InputMultiSelectComponent";
import InputNumberComponent from "../components/inputs/InputNumberComponent";
import InputTextComponent from "../components/inputs/InputTextComponent";
import { UserActivityStatus } from "../model/enum/UserActivityStatus";
import ActivityService from "../services/ActivityService";
import CarService from "../services/CarService";
import ClientService from "../services/ClientService";
import CountryService from "../services/CountryService";
import EmployeeService from "../services/EmployeeService";
import InternalUserService from "../services/InternalUserService";
import ProjectCategoryService from "../services/ProjectCategoryService";
import ProjectService from "../services/ProjectService";
import ToolsService from "../services/ToolsService";
import NumberUtils from "../utils/NumberUtils";
import Constants from "../utils/constants";
import EmployeeStatisticDialog from "./EmployeeStatisticDialog";
import ExtraWorkProjectAggregationDialog from "./ExtraWorkProjectAggregationDialog";
import LogEntryListContainer from "./LogEntryListContainer";
import ProjectDriveCostAggregationDialog from "./ProjectDriveCostAggregationDialog";
import ProjectWorkCostAggregationDialog from "./ProjectWorkCostAggregationDialog";
import ProjectExpensesContainer from './project/expenses/ProjectExpensesContainer';
import ProjectExtraEventListContainer from "./project/extraEvents/ProjectExtraEventListContainer";
import EmployeeProjectPlaningStatistic from "./EmployeeProjectPlaningStatistic";
import IconColorComponent from "../components/inputs/IconColorComponent";
import ExternalSupervisorService from "../services/ExternalSupervisorService";
import StringUtils from "../utils/StringUtils";
import GeoCodingService from "../services/GeoCodingService";
import LocationUtil from "../utils/LocationUtils";
import { Chip } from "primereact/chip";
import CopyLink from "./CopyLink";

import CurrencyUtils from "../components/utils/CurrencyUtils";
import InputCheckboxComponent from "../components/inputs/InputCheckboxComponent";
import {Message} from 'primereact/message';


class ProjectDetailsContainer extends BaseDetailsContainer {

    constructor(props) {
        super(props, new ProjectService());
        this.clientService = new ClientService();
        this.projectCategoryService = new ProjectCategoryService();
        this.countryService = new CountryService();
        this.geoCodingService = new GeoCodingService();
        this.activityService = new ActivityService();
        this.carService = new CarService();
        this.toolsService = new ToolsService();
        this.employeeService = new EmployeeService();
        this.internalUserService = new InternalUserService();

        
        const roleAdmin = this.authService.isUserInRole('ROLE_USER_TYPE_ADMIN');
        const rolePm = this.authService.isUserInRole('ROLE_TIMESHEET_APPROVE');
        const roleEm = this.authService.isUserInRole('ROLE_USER_TYPE_EXTERNAL_MANAGER');
        const currentUser = this.authService.getProfile();

        this.extraWorkEnabled = this.authService.getProfile().extraWorkEnabled;
        this.carEnabled = this.authService.getProfile().carEnabled;
        this.toolboxEnabled = this.authService.getProfile().toolboxEnabled;
        this.projectSupervisorEnabled = this.authService.getProfile().projectSupervisorEnabled;
        this.projectExternalSupervisorEnabled = this.authService.getProfile().projectExternalSupervisorEnabled;
        this.projectExternalManagerEnabled = this.authService.getProfile().projectExternalManagerEnabled;
        this.panelRatioEnabled = this.authService.getProfile().panelRatioEnabled;
        this.supportedPriceType = this.authService.getProfile().supportedPriceType;
        this.projectSettlementCostPresentationStrategy = this.authService.getProfile().projectSettlementCostPresentationStrategy;
        this.allowGroupTimeReporting = this.authService.getProfile().allowGroupTimeReporting;

        this.monthScheduleDateConfig = {
            view: 'month',
            dateFormat: 'mm-yy',
            placeholder: 'mm-yy',
            dateFormatMoment: 'MM-YYYY',
            yearNavigator: true,
        };

        const activeIndexParam = this.navigationContext.getCallerParam('activeIndex');
        this.state = {
            activeIndex: activeIndexParam ? activeIndexParam : 0,
            loading: true,
            downloadingPdf: false,
            elementId: props.elementId,
            leaderRoles: [],
            initLocationCountry: [],
            countryLocationLoaded: false,
            clients: [],
            categories: [],
            activities: [],
            activitiesForTimeReporting: [],
            cars: [],
            users: [],
            tools: [],
            priceTypes: [],
            filteredEmployees: [],
            filteredCars: [],
            projectManagers: [],
            supervisors: [],
            externalSupervisors: [],
            externalManagers: [],
            extraWorkDialogVisible: false,
            extras: [],
            countries: [],
            workCostDialogVisible: false,
            workCosts: [],
            driveCostDialogVisible: false,
            driveCosts: [],
            visibleEmployeeStatistic: false,
            projectAddressIsCustom: false,
            element: {
                name: undefined,
                dateStart: undefined,
                dateEnd: undefined,
                client: undefined,
                categories: [],
                activities: this.extraWorkEnabled ? [{}] : [],
                activitiesForTimeReporting: [{}],
                cars: [],
                users: [{}, {}, {}],
                managers: [{}],
                externalSupervisor: undefined,
                projectManager: undefined,
                externalManager: roleEm && !roleAdmin ? { id: currentUser.subId, fullName: currentUser.name } : undefined,
                supervisor: undefined,
                tools: [],
                projectAddress: this.projectAddressInitial(),
                projectCars: [],
                summary: {
                    unitPrice: { currency: { enumValue: "PLN", label: "Currency.PLN" } },
                    samePriceForAll: true,
                    revenueEmployees: {},
                    revenueExtra: {},
                    revenueTotal: {},
                    costEmployees: {},
                    costDrivers: {},
                    costExpenses: {},
                    costTotal: {},
                    income: {},
                    monthSchedule: [{}]
                }
            },
        };

        this.userDateEndSameAsProject = [];
        this.userDateStartSameAsProject = [];
        this.managerDateEndSameAsProject = [];
        this.managerDateStartSameAsProject = [];


        this.calculateRevenue = this.calculateRevenue.bind(this);
        this.calculateTotalCost = this.calculateTotalCost.bind(this);
        this.calculateIncome = this.calculateIncome.bind(this);
        this.searchEmployees = this.searchEmployees.bind(this);
        this.toolsValueTemplate = this.toolsValueTemplate.bind(this);
        this.alignEmployeesDatesToProject = this.alignEmployeesDatesToProject.bind(this);
        this.persistUsersWithDatesSameAsProject = this.persistUsersWithDatesSameAsProject.bind(this);
        this.fetchUserStatistic = this.fetchUserStatistic.bind(this);
        this.externalSupervisorService = new ExternalSupervisorService();




        this.validator.addCustomRule('at_least_one_field_required', t('validator.at_least_one_field_required'), (value, params) => {
            const tools = this.state.element.tools;
            const index = parseInt(params[0]);
            const tool = tools[index];
            const { car, owner } = tool;
            if (!car && !owner) {
                return false;
            }
            return true;
        },
            (message, params) => message,
            true
        );


        this.validator.addCustomRule('project_date_range', 'Data Od musi być wcześniejsza niż Data Do', value => {
            const { dateStart, dateEnd } = this.state.element;
            return dateStart?.getTime() <= dateEnd?.getTime();
        });

        this.validator.addCustomRule('same_external_manager_for_user_and_project', 'Pracownik musi mieć przypisanego External Managera takiego jak projekt', (value, params) => {
            const { externalManager, users, managers } = this.state.element;
            const index = parseInt(params[0]);
            const userMode = params[1] === 'user';


            if (externalManager) {
                if (userMode) {
                    if (users[index]?.employee?.externalManager?.id !== externalManager.id) {
                        return false;
                    }
                }
                else {
                    if (managers[index]?.employee?.externalManager?.id !== externalManager.id) {
                        return false;
                    }
                }
                //const result = !u && !m;
                //const m = managers.find(m => m?.employee?.externalManager?.id !== externalManager.id);
                return true;
            }
            return true;
        },
            (message, params) => message,
        );


        this.validator.addCustomRule('user_dates_in_project_range', 'Przypisanie użytkownika musi mieścić się w zakresie dat projektu', (value, params) => {
            const index = parseInt(params[0]);
            const usertype = params[1];
            const datetype = params[2];
            if (index === undefined || index === null || index === NaN) {
                return true;
            }
            if (usertype !== 'user' && usertype !== 'manager') {
                throw new Error('Niepoprawny typ użytkownika!');
            }
            if (datetype !== 'start' && datetype !== 'end') {
                throw new Error('Niepoprawny typ daty!');
            }
            const { dateStart, dateEnd } = this.state.element;
            if (!dateStart || !dateEnd) {
                return true;
            }
            const list = usertype === 'user' ? this.state.element.users : this.state.element.managers;
            const user = list[index];
            if (!user.dateStart || !user.dateEnd) {
                return true;
            }
            if (datetype === 'start') {
                if (user.dateStart.getTime() < dateStart.getTime() || user.dateStart.getTime() > dateEnd.getTime()) {
                    return false;
                }
            }
            if (datetype === 'end') {
                if (user.dateEnd.getTime() > dateEnd.getTime() || user.dateEnd.getTime() < dateStart.getTime()) {
                    return false;
                }
            }
            return true;
        },
            (message, params) => message,
        );

        this.validator.addCustomRule('not_duplicate_activities', 'Zduplikowane aktywności prac dodatkowych', (value, params) => {
            const activities = this.state.element.activities;
            const duplicates = activities.filter((item, index) => activities.some((elem, idx) => elem.activity?.id === item.activity?.id && idx !== index));
            if (duplicates.length > 0) {
                return false;
            }
            return true;
        },
            (message, params) => message,
            true
        );


        this.validator.addCustomRule('not_duplicate_activities_time_report', 'Zduplikowane aktywności', (value, params) => {
            const activities = this.state.element.activitiesForTimeReporting;
            const duplicates = activities.filter((item, index) => activities.some((elem, idx) => elem.activity?.id === item.activity?.id && idx !== index));
            if (duplicates.length > 0) {
                return false;
            }
            return true;
        },
            (message, params) => message,
            true
        );




        this.validator.addCustomRule('employee_local_assigment_duplicates', 'Powielona data przypisania do projektu', (value, params) => {
            const userId = value?.id;
            const index = parseInt(params[0]);
            if (!userId || index === undefined || index === null || index === NaN) {
                return true;
            }
            const usertype = params[1];
            if (usertype !== 'user' && usertype !== 'manager') {
                throw new Error('Niepoprawny typ użytkownika!');
            }
            const list = usertype === 'user' ? this.state.element.users : this.state.element.managers;
            const user = list[index];

            if (!user.dateStart || !user.dateEnd) {
                return true;
            }
            const duplicates = list.filter(u => u.dateStart && u.dateEnd && u.employee && u !== user && u?.employee?.id === user?.employee.id)
                .filter(u => {
                    return (user.dateStart.getTime() <= u.dateStart.getTime() && user.dateEnd.getTime() >= u.dateEnd.getTime())
                        || (user.dateStart.getTime() >= u.dateStart.getTime() && user.dateEnd.getTime() <= u.dateEnd.getTime())
                        || (user.dateStart.getTime() <= u.dateStart.getTime() && user.dateEnd.getTime() >= u.dateStart.getTime())
                        || (user.dateStart.getTime() <= u.dateEnd.getTime() && user.dateEnd.getTime() >= u.dateEnd.getTime())
                });
            return duplicates.length == 0;
        },
            (message, params) => message,
        );

        this.validator.addCustomRule('employee_assigment_date_range', 'Data Od nie może być późniejsza niż Data Do', (value, params) => {
            const index = parseInt(params[0]);
            const type = params[1];
            if (index === undefined || index === null || index === NaN) {
                return true;
            }
            if (type !== 'user' && type !== 'manager') {
                throw new Error('Niepoprawny typ!');
            }
            const list = type === 'user' ? this.state.element.users : this.state.element.managers;
            const user = list[index];
            const result = user?.dateStart?.getTime() <= user?.dateEnd?.getTime();
            return result;
        },
            (message, params) => message,
        );

        this.validator.addCustomRule('car_date_start_not_bigger_than_date_to', 'Data Od nie może być późniejsza niż Data Do', (value, params) => {
            const index = parseInt(params[0]);
            const car = this.state.element.projectCars[index];
            return car?.dateStart?.getTime() <= car?.dateEnd?.getTime();
        },
            (message, params) => message,
        );


        this.validator.addCustomRule('car_dates_in_project_range', 'Przypisanie pojazdu musi mieścić się w zakresie dat projektu', (value, params) => {
            const index = parseInt(params[0]);

            const currentProject = this.state.element;
            const car = this.state.element.projectCars[index];

            return currentProject?.dateStart <= car?.dateStart && currentProject?.dateEnd >= car?.dateEnd;
        },
            (message, params) => message,
        );


    }

    getAddSucces() {
        const { t } = this.props;
        return t('project.addUserSuccess');
    }

    getUpdateSucces() {
        const { t } = this.props;
        return t('project.updateUserSuccess');
    }

    fetchUserStatisticAndHandleError(user, userType) {
        this.fetchUserStatistic(user, userType)
            .catch((err) => this.showErrorMessage(err));
    }

    fetchUserStatistic(user, userType) {
        return new Promise((resolve, reject) => {
            const project = this.state.element;
            const list = userType ? project.users : project.managers;
            const listName = userType ? 'users' : 'managers';
            user = list.find(u => u === user);
            if (user.employee && user.dateStart && user.dateEnd) {
                user.renderStats = true;
                user.loadingStats = true;

                this.setState((prevState) => ({
                    element: {
                        ...prevState.element,
                        [listName]: list,
                    },
                }),
                    () => {
                        this.service.getEmployeeProjectPlaningStatistics(user.employee.id, project.id, user.dateStart, user.dateEnd, userType)
                            .then(stats => {
                                const list = userType ? project.users : project.managers;
                                user = list.find(u => u === user);
                                if (user) {
                                    user.stats = stats;
                                    user.loadingStats = false;
                                    this.setState((prevState) => ({
                                        element: {
                                            ...prevState.element,
                                            [listName]: list,
                                        },
                                    }),
                                        () => {
                                            return resolve();
                                        })
                                } else {
                                    return resolve();
                                }
                            }).catch((err) => {
                                return reject('Nie udało się pobrać statystyk użytkownika!');
                            });
                    }
                );
            } else {
                user.renderStats = false;
                this.setState((prevState) => ({
                    element: {
                        ...prevState.element,
                        [listName]: list,
                    },
                }),
                    () => {
                        return resolve();
                    });
            }
        });
    }

    persistUsersWithDatesSameAsProject(callback) {
        const { dateEnd, dateStart, users, managers } = this.state.element;
        const processList = (list, sameDateStartList, sameDateEndList) => {
            sameDateStartList.length = 0;
            sameDateEndList.length = 0;
            list.forEach(u => {
                if (dateEnd) {
                    if (u?.dateEnd?.getTime() == dateEnd?.getTime()) {
                        sameDateEndList.push(u);
                    }
                }
                if (dateStart) {
                    if (u?.dateStart?.getTime() == dateStart?.getTime()) {
                        sameDateStartList.push(u);
                    }
                }
            });
        }
        processList(users, this.userDateStartSameAsProject, this.userDateEndSameAsProject);
        processList(managers, this.managerDateStartSameAsProject, this.managerDateEndSameAsProject);
        callback();
    }

    alignEmployeesDatesToProject() {
        const { dateStart, dateEnd, users, managers } = this.state.element;

        const processList = (list, sameDateStartList, sameDateEndList) => {
            const changes = [];
            list?.forEach(u => {
                if (dateStart && (!u?.dateStart || u?.dateStart?.getTime() < dateStart?.getTime() || sameDateStartList.includes(u))) {
                    u.dateStart = dateStart;
                    if (!changes.find(u2 => u2?.employee?.id == u?.employee?.id)) {
                        changes.push(u);
                    }
                }
                if (dateEnd && (!u?.dateEnd || u?.dateEnd?.getTime() > dateEnd?.getTime() || sameDateEndList.includes(u))) {
                    u.dateEnd = dateEnd;
                    if (!changes.find(u2 => u2?.employee?.id == u?.employee?.id)) {
                        changes.push(u);
                    }
                }
            })
            return changes;
        }
        let errorHandled = false;
        processList(users, this.userDateStartSameAsProject, this.userDateEndSameAsProject)
            .forEach(user => this.fetchUserStatistic(user, true).catch(err => {
                if (!errorHandled) {
                    this.showErrorMessage(err);
                }
                errorHandled = true;

            }))

        processList(managers, this.managerDateStartSameAsProject, this.managerDateEndSameAsProject)
            .forEach(manager => this.fetchUserStatistic(manager, false).catch(err => {
                if (!errorHandled) {
                    this.showErrorMessage(err);
                }
                errorHandled = true;
            }))


        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                users,
                managers
            },
        }));
    }


    projectAddressInitial() {

        return {
            id: undefined,
            project: {
                id: this.props.elementId,
            },
            address: {
                streetNumber: '',
                houseNumber: '',
                streetName: '',
                postalCode: '',
                city: '',
                country: undefined,
            },
            location: {
                longitude: '',
                latitude: ''  
            }
        }
    }

    searchEmployees(query, userId, mode) {
        //removing already defined
        let showOnlyLeaders = false;
        if (mode === 'managers') {
            showOnlyLeaders = true;
        }
        this.employeeService.search(query, showOnlyLeaders, UserActivityStatus.ACTIVE)
            .then(filteredEmployees => {
                this.setState({ filteredEmployees })
            }
            ).catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy pracowników');
            });


    }

    searchCars(query) {
        const list = [];
        this.carService
            .searchCars(query, 'ACTIVE', null).then(data => {
                this.setState({
                    filteredCars: list.concat(data)
                })
            })
    }

    getClonedElement(data) {
        let preparedName = `(Kopia) ${data.name}`;
        return {
            name: preparedName,
            dateStart: data.dateStart ? moment(data.dateStart).toDate() : undefined,
            dateEnd: data.dateEnd ? moment(data.dateEnd).toDate() : undefined,
            client: data.client,
            users: data?.users.map(x => {
                return {
                    employee: x.employee,
                    dateStart: x.dateStart,
                    dateEnd: x.dateEnd
                }
            }),
            managers: data.managers.map(x => {
                return {
                    employee: x.employee,
                    dateStart: x.dateStart,
                    dateEnd: x.dateEnd,
                    roleType: x.roleType
                }
            }),
            tools: data.tools.map(x => {
                return {
                    tools: x.tools,
                    owner: x.owner,
                    car: x.car
                }
            }),
            projectAddress: !data.projectAddress ? this.projectAddressInitial() : {
                "address": data.projectAddress.address,
                "location": data.projectAddress.location
            },
            projectCars: data?.projectCars.map(x => {
                return {
                    car: x.car,
                    project: {
                        name: x.project.name,
                    },
                    dateStart: x.dateStart,
                    dateEnd: x.dateEnd,

                }
            }),
            activities: data?.activities.map(x => {
                return {
                    activity: x.activity,
                    price: x.price,
                    currency: x.currency,
                    usedFor: x.usedFor
                }
            }),
            categories: data.categories,
            externalSupervisor: data.externalSupervisor,
            projectManager: data.projectManager,
            externalManager: data.externalManager,
            supervisor: data.supervisor,
            summary: {
                unitPrice: { currency: { enumValue: "PLN", label: "Currency.PLN" } },
                revenueEmployees: {},
                revenueExtra: {},
                revenueTotal: {},
                costEmployees: {},
                costDrivers: {},
                costExpenses: {},
                costTotal: {},
                income: {},
            },
            expenses: [],
            kwpNumber: null,
            panelNumber: null,
            status: { enumValue: 'ACTIVE', label: 'Aktywny' }
        };
    }


    cloneProject(data) {
        let element = this.getClonedElement(data);

        if (element.users) {
            element.users.sort((u1, u2) => {
                if (u1?.employee?.fullName > u2?.employee?.fullName) return 1;
                if (u1?.employee?.fullName < u2?.employee?.fullName) return -1;
                return 0;
            });
            element.users.forEach(u => {
                if (u.dateStart) {
                    u.dateStart = moment(u.dateStart).toDate();
                }
                if (u.dateEnd) {
                    u.dateEnd = moment(u.dateEnd).toDate();
                }
            })
        }
        if (element.projectCars) {
            element.projectCars.forEach(pc => {
                if (pc.dateStart) {
                    pc.dateStart = moment(pc.dateStart).toDate();
                }
                if (pc.dateEnd) {
                    pc.dateEnd = moment(pc.dateEnd).toDate();
                }
            })
        }
        if (element.managers) {
            element.managers.sort((m1, m2) => {
                if (m1?.employee?.fullName > m2?.employee?.fullName) return 1;
                if (m1?.employee?.fullName < m2?.employee?.fullName) return -1;
                return 0;
            });
            element.managers.forEach(m => {
                if (m.dateStart) {
                    m.dateStart = moment(m.dateStart).toDate();
                }
                if (m.dateEnd) {
                    m.dateEnd = moment(m.dateEnd).toDate();
                }
            })
        }

        if (element.activities) {
            element.activities.sort((a1, a2) => {
                if (a1?.activity?.name > a2?.activity?.name) return 1;
                if (a1?.activity?.name < a2?.activity?.name) return -1;
                return 0;
            })
            const extraWorkActivities = element.activities.filter(a => a.usedFor === 'EXTRA_WORKS');
            const timeReportingActivities = element.activities.filter(a => a.usedFor === 'TIME_REPORTING');
            element.activities = extraWorkActivities;
            element.activitiesForTimeReporting = timeReportingActivities;
        }


        this.setState(
            {
                element: element
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }



    updateElement(data) {        
        if (data.dateStart) {
            data.dateStart = moment(data.dateStart).toDate();
        }
        if (data.dateEnd) {
            data.dateEnd = moment(data.dateEnd).toDate();
        }
        if (!data.summary) {
            data.summary = {};
        }
        if (!data.summary.unitPrice) {
            data.summary.unitPrice = {};
        }
        if (!data.summary.revenueEmployees) {
            data.summary.revenueEmployees = {};
        }
        if (!data.summary.revenueExtra) {
            data.summary.revenueExtra = {};
        }
        if (!data.summary.revenueTotal) {
            data.summary.revenueTotal = {};
        }
        if (!data.summary.costEmployees) {
            data.summary.costEmployees = {};
        }
        if (!data.summary.costDrivers) {
            data.summary.costDrivers = {};
        }
        if (!data.summary.costExpenses) {
            data.summary.costExpenses = {};
        }
        if (!data.summary.costTotal) {
            data.summary.costTotal = {};
        }
        if (!data.summary.income) {
            data.summary.income = {};
        }
        if (!data.projectAddress) {
            data.projectAddress = this.projectAddressInitial();
        }
        if (data.users) {
            data.users.sort((u1, u2) => {
                if (u1?.employee?.fullName > u2?.employee?.fullName) return 1;
                if (u1?.employee?.fullName < u2?.employee?.fullName) return -1;
                return 0;
            });
            data.users.forEach(u => {
                if (u.dateStart) {
                    u.dateStart = moment(u.dateStart).toDate();
                }
                if (u.dateEnd) {
                    u.dateEnd = moment(u.dateEnd).toDate();
                }
            })
        }
        if (data.projectCars) {
            data.projectCars.forEach(pc => {
                if (pc.dateStart) {
                    pc.dateStart = moment(pc.dateStart).toDate();
                }
                if (pc.dateEnd) {
                    pc.dateEnd = moment(pc.dateEnd).toDate();
                }
            })
        }
        if (data.managers) {
            data.managers.sort((m1, m2) => {
                if (m1?.employee?.fullName > m2?.employee?.fullName) return 1;
                if (m1?.employee?.fullName < m2?.employee?.fullName) return -1;
                return 0;
            });
            data.managers.forEach(m => {
                if (m.dateStart) {
                    m.dateStart = moment(m.dateStart).toDate();
                }
                if (m.dateEnd) {
                    m.dateEnd = moment(m.dateEnd).toDate();
                }
            })
        }
        if (data.activities) {
            data.activities.sort((a1, a2) => {
                if (a1?.activity?.name > a2?.activity?.name) return 1;
                if (a1?.activity?.name < a2?.activity?.name) return -1;
                return 0;
            })
            const extraWorkActivities = data.activities.filter(a => a.usedFor === 'EXTRA_WORKS');
            const timeReportingActivities = data.activities.filter(a => a.usedFor === 'TIME_REPORTING');
            data.activities = extraWorkActivities;
            data.activitiesForTimeReporting = timeReportingActivities;

        }

        if (data.expenses) {
            data.expenses.sort((e1, e2) => {
                if (e1?.date > e2?.date) return 1;
                if (e1?.date < e2?.date) return -1;
                return 0;
            })
        }

        const projectAddressIsCustom = !this.isSameAddress(data?.client?.address, data?.projectAddress);

        this.setState(
            {
                element: data,
                headerProjectName: data.name,
                headerProjectStatus: data.status,
                projectAddressIsCustom
            },
            () => {
                this.initAfterSetElement();
            }
        )
    }

    isSameAddress(clientAddress, projectAddress) {
        if (clientAddress?.country?.name !== projectAddress?.country?.name) {
            return false;
        }
        if (clientAddress?.postalCode !== projectAddress?.postalCode) {
            return false;
        }
        if (clientAddress?.city !== projectAddress?.city) {
            return false;
        }
        if (clientAddress?.streetName !== projectAddress?.streetName) {
            return false;
        }
        if (clientAddress?.streetNumber !== projectAddress?.streetNumber) {
            return false;
        }
        if (clientAddress?.houseNumber !== projectAddress?.houseNumber) {
            return false;
        }
        return true;
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId} = this.state;
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId, viewMode)
                .then((data) => {
                    this.setState({loading: false}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else if (elementId && this.props.viewMode === 'NEW') { //sklonuj jesli tryb tworzenia i jest przekazany ID
            this.blockUi();
            this.service
                .get(elementId, viewMode)
                .then((data) => {
                    this.setState({loading: false}, () => {
                        this.cloneProject(data); //sklonuj to co potrzeba, dodaj sufiks 'Kopia'
                    });
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }


    initAfterSetElement() {
        super.initAfterSetElement();



        const { users, managers } = this.state.element;
        let errorHandled = false;

        const roleAdmin = this.authService.isUserInRole('ROLE_USER_TYPE_ADMIN');
        const rolePm = this.authService.isUserInRole('ROLE_TIMESHEET_APPROVE');
        const roleSupervisor = this.authService.isUserInRole('ROLE_USER_TYPE_SUPERVISOR');
        const roleFm = this.authService.isUserInRole('ROLE_PROJECT_FINANCE_ACCESS');
        this.state.element.activities.forEach(a => {
            if (!this.state.activities.map((x) => x.id).includes(a?.activity?.id)) {
                if (a.activity == null || a.activity == {}) {
                    return;
                }
                this.state.activities.push({
                    ...a.activity,
                    className: ''
                });
            }
        })

        this.state.element.categories.forEach(c => {
            if (!this.state.categories.map((x) => x.id).includes(c.id)) {
                this.state.categories.push(c);
            }
        });

        if (this.state.element.client != null && (this.state.clients == null || !this.state.clients?.map(c => c.id).includes(this.state.element.client.id))) {
            this.state.clients.push(this.state.element.client);
        }
        this.initLocationsCountry()
        //Brak potrzeby fetchowania statystyk jesli user jest tylko financial managerem, ma tylko dostep do zakladki rozliczenie
        if (roleAdmin || rolePm || roleSupervisor) {
            users.forEach(user => {
                this.fetchUserStatistic(user, true).catch(err => {
                    if (!errorHandled) {
                        this.showErrorMessage(err);
                    }
                    errorHandled = true;
                })
            })
            managers.forEach(manager => {
                this.fetchUserStatistic(manager, false).catch(err => {
                    if (!errorHandled) {
                        this.showErrorMessage(err);
                    }
                    errorHandled = true;
                })
            })
        }

    }

    initLocationsCountry = () => {
        const location = this.state.element?.projectAddress?.location;
        const isLatitudeNotFilled = StringUtils.isBlank(location?.latitude);
        const isNotCloningMode = this.props.viewMode === "NEW" && !this.state.elementId;

        if (isNotCloningMode || isLatitudeNotFilled) {
            const { address } = this.state.element.projectAddress;
            const countryLocation = LocationUtil.getCountryLocationOrDefault(address?.country?.name)
            this.setLocation(countryLocation[0], countryLocation[1]);
        }else{
            this.setLocation(location.latitude, location.longitude);
        }
    };

    initLocationsCountryFromClient = () => {
        const address = this.state.element?.client?.address;
        const countryLocation = LocationUtil.getCountryLocationOrDefault(address?.country?.name)
        this.setLocation(countryLocation[0], countryLocation[1]);
    };

    setLocation = (lat, lng) => {
        const isValidCoordinate =!StringUtils.isBlank(lat) && !StringUtils.isBlank(lng);
        this.setState({
            initLocationCountry: isValidCoordinate ? [lat, lng] : [],
            countryLocationLoaded: true
        });
    };


    initBeforeSetElement() {
        this.activityService.getList({ status: { enumValue: 'ACTIVE' }, firstResult: 0, maxResults: 1000, sortField: 'name', sortAsc: true })
            .then(activities => {
                this.setState({ activities: activities.content.filter(a => a.useForExtraWorks === true),
                    activitiesForTimeReporting: activities.content.filter(a => a.useForTimeReporting === true) })
                if (activities.content.filter(a => a.useForTimeReporting === true).length == 0) {
                    this.setState(prev => {
                        return {
                            element: {
                                ...prev.element,
                                activitiesForTimeReporting: []
                            }
                        }
                    })
                }
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy aktywności');
            });

        if (this.props.viewMode === 'VIEW') {
            return;
        }
        const roleFinanceAccess = this.authService.isUserInRole('ROLE_PROJECT_FINANCE_ACCESS');

        //Dla filtrow 
        this.projectCategoryService.getList({ status: { enumValue: 'ACTIVE' }, firstResult: 0, maxResults: 1000, sortField: 'name', sortAsc: true })
            .then(categories => this.setState({ categories: categories.content }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy kategorii');
            });
        this.enumService.getEnumList('ProjectManagerRoleType')
            .then(leaderRoles => {
                this.setState({ leaderRoles });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy ról liderów');
            });
        this.internalUserService.getSimpleList('ROLE_TIMESHEET_APPROVE')
            .then(users => this.setState({ projectManagers: users }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy menedżerów');
            });
        this.internalUserService.getSimpleList(['ROLE_USER_TYPE_SUPERVISOR', 'ROLE_TIMESHEET_APPROVE'])
            .then(users => this.setState({ supervisors: users }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy menedżerów');
            });
        this.internalUserService.getSimpleList(['ROLE_USER_TYPE_EXTERNAL_MANAGER'])
            .then(users => this.setState({ externalManagers: users }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy menedżerów zewnętrznych');
            });
        this.externalSupervisorService
            .getList({ status: { enumValue: 'ACTIVE' }, firstResult: 0, maxResults: 1000, sortField: 'lastName', sortAsc: true })
            .then(data => this.setState({ externalSupervisors: data.content }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy opiekunów');
            });

        if (roleFinanceAccess) { // Dla zakladki Rozliczenie
            this.enumService
                .getEnumList('Currency')
                .then(currencies => this.setState({ currencies }))
                .catch(() => {
                    this.showErrorMessage('Nie udało się pobrać listy walut');
                });    
            this.enumService
                .getEnumList('PriceType')
                .then(priceTypes => {
                    priceTypes.forEach(pt => pt.label = t(pt.label));
                    this.setState({ priceTypes: priceTypes.filter(pt => this.supportedPriceType?.indexOf(pt.enumValue) >= 0)});
                })
                .catch(() => {
                    this.showErrorMessage('Nie udało się pobrać listy rodzajów rozliczenia');
                });
        }
        //if (roleAdmin || roleCto || rolePm || roleSupervisor || roleEm) { //Do pozostalych zakladek do ktorych maja dostep inni userzy
        this.countryService.getAll()
            .then((countries) => {
                this.setState({ countries });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy krajów');
            });
        this.clientService.getList({ status: { enumValue: 'ACTIVE' }, firstResult: 0, maxResults: 1000, sortField: 'name', sortAsc: true })
            .then(clients => this.setState({ clients: clients.content }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy klientów');
            });


        this.carService.getList({ status: { enumValue: 'ACTIVE' }, firstResult: 0, maxResults: 1000, sortField: 'licensePlate', sortAsc: true })
            .then(cars => this.setState({ cars: cars.content }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy pojazdów');
            });
        this.toolsService.getList({ status: { enumValue: 'ACTIVE' }, firstResult: 0, maxResults: 1000, sortField: 'name', sortAsc: true })
            .then(tools => this.setState({ tools: tools.content }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy narzędzi');
            });
        //}

    }

    handleGetDetailsError(err) {
        this.showErrorMessage('Błąd podczas pobrania szczegółów');
        if (this.props.backUrl) {
            this.blockUi();
            this.persistMessage('error', '', err.message);
            window.location.href = this.navigationContext.addNavigationContextToUrl(this.props.backUrl);
        } else {
            this.setState({ loading: false }, () => this.unblockUi());
        }
    }

    isFormValid(callback) {
        const initActiveIndex = this.state.activeIndex;
        const scrollableContainer = document.getElementById('main-container'); 
        const scrollPosition = scrollableContainer?.scrollTop;   
        this.setState({ activeIndex: 0 }, () => {
            if (this.validator.allValid()) {
                this.setState({ activeIndex: 1 }, () => {
                    if (this.validator.allValid()) {
                        this.setState({ activeIndex: 2 }, () => {
                            if (this.validator.allValid()) {
                                this.setState({ activeIndex: 5 }, () => {
                                    if (this.validator.allValid()) {
                                        this.setState({ activeIndex: initActiveIndex }, () => {
                                            scrollableContainer?.scrollTo(0, scrollPosition);
                                            callback(true);
                                        });
                                    } else {
                                        callback(false);
                                    }
                                })

                            } else {
                                callback(false);
                            }
                        });

                    } else {
                        callback(false);
                    }
                })

            } else {
                callback(false);
            }
        });

    }
    
    prepareFooterItems() {
        const result = super.prepareFooterItems();
        const { viewMode, editUrl } = this.props;
        const { element } = this.state;
        switch (viewMode) {
            case 'EDIT':
            case 'NEW':
                break;
            case 'VIEW':
                if (this.authService.isUserInAnyRole('ROLE_TIMESHEET_APPROVE', 'ROLE_USER_TYPE_ADMIN')) {                    
                    if (element?.status?.enumValue === 'ACTIVE') {
                        const href = this.navigationContext.addNavigationContextToUrl(`${editUrl}/${element.id}`);
                        result.push({ label: t('global.editButton'), className: 'float-right', href: href })
                    }
                    if (element?.status?.enumValue === 'ACTIVE') {
                        result.push(this.prepareCloseProjectButton());
                    }
                }
                break;
            default:
                break;        
            }
        return result;
    }


    prepareCloseProjectButton() {
        return {
            label: t('project.details.closeProjectButton'),
            type: 'BUTTON',
            variant: '',
            className: 'float-right fullred ',
            onClick: () => {
                this.setState({
                    showConfirmCloseProject: true,
                });
            },
            rendered: true,
            iconSide: 'left',
            iconSize: 'm',
        };
    }


    isPdfButtonRendered() {
        return false;
    }

    getPdfDownloadLabel() {
        return null;
    }

    handleDownloadPdf() {
    }


    createQueryString(queryObject = {}) {
        let queryString = Object.keys(queryObject)
            .filter((key) => queryObject[key] && !(Array.isArray(queryObject[key]) && !queryObject[key].length))
            .map((key) => {
                return Array.isArray(queryObject[key]) ? queryObject[key].map(item => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`).join('&') : `${encodeURIComponent(key)}=${encodeURIComponent(queryObject[key])}`;
            }).join('&');
        return queryString ? `?${queryString}` : "";
    };


    carTemplate(rowData, props) {
        const { rowIndex } = props;
        return (
            <div>
                <div style={{ marginTop: "14px" }}>
                    <InputAutocompleteComponent
                        id={`car${rowIndex}`}
                        name="car"
                        colClass='col-md-7'
                        label={t('project.details.car')}
                        value={rowData.car}
                        dropdown
                        forceSelection
                        viewMode={this.props.viewMode}
                        validator={this.validator}
                        validators={`required`}
                        showLabel={false}
                        onChange={this.handleChange}
                        insideTable={true}
                        filteredList={this.state.filteredCars}
                        filterList={query => this.searchCars(query)}
                        field="licensePlate"
                        stateField={`element.projectCars[${rowIndex}]`}
                        minLength={3}
                        placeholder={t('search.cars.placeholder')}
                    />
                </div>
            </div>
        )
    }
    carStartDateTemplate(rowData, props) {
        const { rowIndex } = props;
        return (
            <InputCalendarComponent
                id={`employeeDateStart${rowIndex}`}
                colClass='col-md-2'
                name="dateStart"
                label='Od'
                value={rowData.dateStart}
                onChange={(x, xx, event) => {
                    rowData.dateStart = event.value;
                }}
                viewMode={this.props.viewMode}
                validator={this.validator}
                validators={`required|car_date_start_not_bigger_than_date_to:${rowIndex}|car_dates_in_project_range:${rowIndex}`}
                stateField={`element.projectCars[${rowIndex}]`}
                insideTable
                showLabel={false}
                showIcon
            />
        )
    }
    carEndDateTemplate(rowData, props) {
        const { rowIndex } = props;
        return (
            <InputCalendarComponent
                id={`employeeDateEnd${rowIndex}`}
                colClass='col-md-2'
                name="dateEnd"
                label='Do'
                value={rowData.dateEnd}
                onChange={(x, xx, event) => {
                    rowData.dateEnd = event.value;
                }}
                viewMode={this.props.viewMode}
                validator={this.validator}
                validators={`required|car_date_start_not_bigger_than_date_to:${rowIndex}|car_dates_in_project_range:${rowIndex}`}
                stateField={`element.projectCfars[${rowIndex}]`}
                insideTable
                showLabel={false}
                showIcon
            />
        )
    }
    carActionsTemplate(rowData, props) {
        const { rowIndex } = props;
        const projectCar = rowData;
        return (
            <div className="col-md-1">
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    rendered={this.props.viewMode != 'VIEW'}
                    handleClick={(e) => {
                        const projectCars = this.state.element.projectCars.filter(pc => pc != projectCar);
                        this.setState((prevState) => ({
                            element: {
                                ...prevState.element,
                                projectCars,
                            },
                        }));
                    }}
                    variant='blue'
                    className='edit-blue-link'
                    key={'delete-button'}
                />
            </div>
        )
    }
    handleAddNewCar() {
        const { projectCars, dateStart, dateEnd } = this.state.element;
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                projectCars: projectCars.concat({ dateStart, dateEnd }),
            },
        }));
    }

    renderTopPanel() {
        const { viewMode } = this.props;
        const status = this.state.headerProjectStatus;
        const projectName = viewMode === 'NEW' ? 'Nowy projekt' : this.state.headerProjectName;
        const noData = !status;
        const isActive = status?.enumValue === 'ACTIVE';


        return (
            <React.Fragment>
                <span className="top-panel-large-label">{projectName}</span>
                {noData ? (null) : (
                    <React.Fragment>
                        <CopyLink textToCopy={projectName} defaultText='Skopiuj nazwę'/>
                        <Chip
                            label={status?.label}
                            className={isActive ? 'project-status-active' : 'project-status-closed'}
                        />
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }

    formatExternalSupervisor(supervisor) {
        let result = '';
        if (supervisor?.fullName) {
            result += supervisor.fullName;
        }
        if (supervisor?.email) {
            result += '\n' + supervisor.email;
        }
        if (supervisor?.phoneNumber) {
            result += '\n' + supervisor.phoneNumber;
        }
        return result;
    }

    formatAddress(address) {
        let result = address?.country?.name;
        result += ', ';
        result += this.formatAddressCityName(address);
        result += ', ';
        result += this.formatAddressStreetName(address);
        return result;
    }

    formatAddressCityName(address) {
        let result = '';
        if (address?.postalCode) {
            result += address.postalCode + ' ';
        }
        if (address?.city) {
            result += address.city;
        }
        return result;
    }

    formatAddressStreetName(address) {
        let result = '';
        if (address?.streetName) {
            result += address.streetName + ' ';
        }
        if (address?.streetNumber) {
            result += address.streetNumber;
        }
        if (address?.houseNumber) {
            result += '/' + address.houseNumber;
        }
        return result;
    }


    renderDetails() {
        
        const costEmployees =  this.projectSettlementCostPresentationStrategy === 'ALL' ? this.state.element?.summary?.costEmployees?.value + this.state.element?.summary?.costOfficeEmployees?.value : this.state.element?.summary?.costEmployees?.value;
        const hoursEmployees = this.projectSettlementCostPresentationStrategy === 'ALL' ? this.state.element?.summary?.hoursEmployees + this.state.element?.summary?.hoursOfficeEmployees : this.state.element?.summary?.hoursEmployees ;
        const extraDetailsRendered = this.props.viewMode !== 'NEW' && this.state.element?.summary?.revenueExtra?.value > 0;
        const workCostRendered = this.props.viewMode !== 'NEW' && costEmployees > 0;
        const officeWorkCostRendered = this.props.viewMode !== 'NEW' && this.state.element?.summary?.costOfficeEmployees?.value > 0;
        const driveCostRendered = this.props.viewMode !== 'NEW' && this.state.element?.summary?.costDrivers?.value > 0;;
        const roleAdmin = this.authService.isUserInRole('ROLE_USER_TYPE_ADMIN');
        const rolePm = this.authService.isUserInRole('ROLE_TIMESHEET_APPROVE');
        const roleSupervisor = this.authService.isUserInRole('ROLE_USER_TYPE_SUPERVISOR');
        const roleFinanceAccess = this.authService.isUserInRole('ROLE_PROJECT_FINANCE_ACCESS');
        const roleExternalManager = this.authService.isUserInRole('ROLE_USER_TYPE_EXTERNAL_MANAGER');

        const clientAddress = this.state?.element?.client?.address;
        const externalSupervisor = this.state?.element?.externalSupervisor;


        const summaryKwpNumber = () => {
            const valueExists = this.state.element?.kwpNumber
            if (this.supportedPriceType?.indexOf('KWP') < 0) {
                return null;
            }
            return valueExists || this.props.viewMode !== 'VIEW' ? (
                <InputNumberComponent
                    id='kwpNumber'
                    name='kwpNumber'
                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-6'
                    label={t('project.details.kwpNumber')}
                    value={valueExists || this.props.viewMode !== 'VIEW' ? this.state.element.kwpNumber : 'Brak danych'}
                    onChange={this.handleChange}
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators='not_required'
                    onAfterStateChange={this.calculateRevenue}
                    minFractionDigits={0}
                    maxFractionDigits={2}
                    mode={'decimal'}
                />) : (
                    <InputTextComponent
                        id='kwpNumberEmpty'
                        name='kwpNumberEmpty'
                        colClass='col-xl-6 col-lg-6 col-md-6 col-sm-6'
                        label={t('project.details.kwpNumber')}
                        value={'Brak danych'}
                        onChange={this.handleChange}
                        viewMode={'VIEW'}
                        validator={this.validator}
                        validators='not_required'
                />
            )
        }

        const summaryPanelNumber = () => {
            const valueExists = this.state.element?.panelNumber
            if (this.supportedPriceType?.indexOf('PANEL') < 0) {
                return null;
            }
            return valueExists || this.props.viewMode !== 'VIEW' ? (
                <InputNumberComponent
                    id='panelNumber'
                    name='panelNumber'
                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-6'
                    label={t('project.details.panelNumber')}
                    value={this.state.element.panelNumber}
                    onChange={this.handleChange}
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators='not_required'
                    onAfterStateChange={this.calculateRevenue}
                    minFractionDigits={0}
                    maxFractionDigits={2}
                    mode={'decimal'}
                />) : (
                <InputTextComponent
                    id='panelNumberEmpty'
                    name='panelNumberEmpty'
                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-6'
                    label={t('project.details.panelNumber')}
                    value={'Brak danych'}
                    onChange={this.handleChange}
                    viewMode={'VIEW'}
                    validator={this.validator}
                    validators='not_required'
                />
            );               
        };
        


        return (
            <React.Fragment>

                <DivContainer colClass='row'>
                    <EmployeeStatisticDialog
                        visible={this.state.visibleEmployeeStatistic}
                        onHide={() => this.setState({ visibleEmployeeStatistic: false })}
                        user={this.state.selectedEmployee}
                        stats={this.state.selectedEmployeeStats}
                        dateStart={this.state.selectedEmployeeDateStart}
                        dateEnd={this.state.selectedEmployeeDateEnd}
                    />

                    <DivContainer colClass='col-md-12'>
                        <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => {
                            this.navigationContext.addOrUpdateParam('activeIndex', e.index);
                            this.setState({ activeIndex: e.index });
                        }} >

                            <TabPanel header={t('project.details.mainTabHeader')}>
                                <div className='row profile'>
                                    <div className='col-12 col-xs-12 col-sm-12 col-md-8 details-card-wrapper' >
                                        <Card
                                            className='data-card'
                                            header={() => {
                                                return (
                                                    <div className='card-header-with-icon-container'>
                                                        <i className='mdi mdi-information'/>
                                                        <span>{t('project.details.baseInformation')}</span>
                                                    </div>
                                                )
                                            }}
                                        >
                                            <DivContainer colClass='row'>
                                                <InputTextComponent
                                                    id='project-name'
                                                    name='name'
                                                    label={t('project.details.name')}
                                                    colClass='col-md-12'
                                                    value={this.state.element.name}
                                                    validators='required|max:150'
                                                    validator={this.validator}
                                                    onChange={this.handleChange}
                                                    viewMode={this.props.viewMode}
                                                />
                                            </DivContainer>


                                            <DivContainer colClass='row'>
                                                <InputDropdownComponent
                                                    id='client'
                                                    name='client'
                                                    label={t('project.details.client')}
                                                    colClass='col-md-12'
                                                    value={this.state.element.client}
                                                    valueView={this.state.element?.client?.name}
                                                    dataKey='id'
                                                    options={this.state.clients}
                                                    optionLabel='name'
                                                    viewMode={this.props.viewMode}
                                                    validator={this.validator}
                                                    validators='required'
                                                    onChange={this.handleChange}
                                                    filter
                                                    filterBy='name'
                                                    onAfterStateChange={() => {
                                                        this.initLocationsCountryFromClient();
                                                    }}
                                                    rendered={false}
                                                />
                                                <InputMultiSelectComponent
                                                    id='categories'
                                                    name='categories'
                                                    label={t('project.details.categories')}
                                                    colClass='col-md-12'
                                                    onChange={this.handleChange}
                                                    options={this.state.categories}
                                                    optionLabel='name'
                                                    value={this.state.element.categories}
                                                    viewMode={this.props.viewMode}
                                                    dataKey='id'
                                                    //selectedItemTemplate={this.selectedItemTemplate}
                                                    filter
                                                    filterBy='name'
                                                    display='chip-colored'
                                                    chipColor='color.value'
                                                />
                                                <InputCalendarRangeComponent
                                                    id='date'
                                                    idFrom='projectDateStart'
                                                    idTo='projectDateEnd'
                                                    nameFrom='dateStart'
                                                    nameTo='dateEnd'
                                                    labelFrom={t('project.details.dateStart')}
                                                    labelTo={t('project.details.dateEnd')}
                                                    dateFormatMoment={Constants.DATE_FORMAT}
                                                    colClass='col-md-12'
                                                    from={this.state.element.dateStart}
                                                    to={this.state.element.dateEnd}
                                                    validator={this.validator}
                                                    validators='required|project_date_range'
                                                    validatorsTo='required'
                                                    onChange={this.handleChange}
                                                    viewMode={this.props.viewMode}
                                                    showIcon={true}
                                                    onAfterStateChange={this.alignEmployeesDatesToProject}
                                                    onBeforeStateChange={callback => this.persistUsersWithDatesSameAsProject(callback)}
                                                    rendered={this.props.viewMode !== 'VIEW'}
                                                />
                                                <InputTextComponent
                                                    rendered={this.props.viewMode === 'VIEW'}
                                                    label={'Data projektu'}
                                                    value={`${moment(this.state.element.dateStart).format('DD-MM-YYYY')} - ${moment(this.state.element.dateEnd).format('DD-MM-YYYY')}`}
                                                    id='projectDateRange'
                                                    name='projectDateRange'
                                                    colClass='col-md-12'
                                                />

                                                {this.panelRatioEnabled ? (
                                                    <InputTextComponent
                                                        id='panelRatio'
                                                        name='panelRatio'
                                                        value={NumberUtils.formatNumber(this.state.element?.summary?.panelRatio, 6, 6)}
                                                        viewMode={'VIEW'}
                                                        label={t('project.details.panelRatio')}
                                                    />
                                                ) : null} 
                                            </DivContainer>
                                        </Card>
                                    </div>
                                    <div className='col-12 col-xs-12 col-sm-12 col-md-4 details-card-wrapper'>
                                        <Card
                                            className='data-card'
                                            header={() => {
                                                return (
                                                    <div className='card-header-with-icon-container'>
                                                        <i className='mdi mdi-card-account-details'/>
                                                        <span>{t('project.details.client')}</span>
                                                    </div>
                                                )
                                            }}
                                        >
                                            <div className="row">
                                                <InputDropdownComponent
                                                        id='client'
                                                        name='client'
                                                        label={t('project.details.client')}
                                                        colClass='col-md-12'
                                                        value={this.state.element.client}
                                                        valueView={this.state.element?.client?.name}
                                                        dataKey='id'
                                                        options={this.state.clients}
                                                        optionLabel='name'
                                                        viewMode={this.props.viewMode}
                                                        validator={this.validator}
                                                        validators='required'
                                                        onChange={this.handleChange}
                                                        filter
                                                        filterBy='name'
                                                        onAfterStateChange={() => {
                                                            this.initLocationsCountryFromClient();
                                                        }}
                                                    />
                                                </div>
                                                {clientAddress?.country?.name ? (
                                                <div className='row'>
                                                    <InputTextComponent label='Adres' colClass='col-6' value={clientAddress.country.name} />
                                                    <InputTextComponent showLabel={false} colClass='col-12' value={this.formatAddressCityName(clientAddress)} />
                                                    <InputTextComponent showLabel={false} colClass='col-8' value={this.formatAddressStreetName(clientAddress)} />
                                                    <div>
                                                        <CopyLink  textToCopy={this.formatAddress(clientAddress)} defaultText={'Skopiuj adres'}/>
                                                    </div>
                                                </div>
                                                ) : null}
                                                {externalSupervisor ? (
                                                    <div className='row'>
                                                        <InputTextComponent label='Opiekun' colClass='col-12' value={externalSupervisor.fullName}/>
                                                        <InputTextComponent showLabel={false} colClass='col-12' value={externalSupervisor?.email} rendered={externalSupervisor?.email}/>
                                                        <InputTextComponent showLabel={false} colClass='col-12' value={externalSupervisor?.phoneNumber} rendered={externalSupervisor?.phoneNumber}/>
                                                        <div>
                                                            <CopyLink  textToCopy={this.formatExternalSupervisor(externalSupervisor)} defaultText={'Skopiuj dane'}/>
                                                        </div>
                                                    </div>
                                                ) : null}

                                        </Card>
                                    </div>
                                    <div className='col-12 col-xs-12 col-sm-12 col-md-12 details-card-wrapper' >
                                        <Card
                                            header={() => {
                                                return (
                                                    <div className='card-header-with-icon-container'>
                                                        <i className='mdi mdi-compass-outline'/>
                                                        <span>{t('project.details.localization')}</span>
                                                    </div>
                                                )
                                            }}
                                            className='data-card'>
                                        {this.state.countryLocationLoaded && <LocationAddressComponent
                                                showLocationTolerance={true}
                                                initCountryLocation={this.state.initLocationCountry.length === 0 ? Constants.POLAND_LOCATION : this.state.initLocationCountry}
                                                handleChangeLocationTolerance={(locationToleranceInKilometers)=>{
                                                    this.setState((prevState) => ({
                                                        element: {
                                                        ...prevState.element,
                                                        projectAddress: {
                                                            ...prevState.element.projectAddress,
                                                            locationToleranceInKilometers
                                                        },
                                                        },
                                                    })); 
                                                }}
                                                handleChangeAddress={(res, callback)=>{
                                                    this.setState((prevState) => ({
                                                        element: {
                                                        ...prevState.element,
                                                        projectAddress: {
                                                            ...prevState.element.projectAddress,
                                                            address: {
                                                            city: res.city,
                                                            country: res.country,
                                                            streetNumber: res.streetNumber,
                                                            postalCode: res.postalCode,
                                                            streetName: res.streetName,
                                                            houseNumber: res.houseNumber,
                                                            },
                                                        },
                                                        },
                                                    }), () => callback ? callback() : null);
                                                }}
                                                handleChangeLocation={(res)=>{
                                                    this.setState((prevState) => ({
                                                        element: {
                                                        ...prevState.element,
                                                        projectAddress: {
                                                            ...prevState.element.projectAddress,
                                                            location: {
                                                                latitude: res.length === 0 ? undefined : res[0].latitude,
                                                                longitude: res.length === 0 ? undefined : res[0].longitude,
                                                            },
                                                            locationToleranceInKilometers: res.length === 0 ? undefined : this.state.element.projectAddress?.locationToleranceInKilometers,
                                                        },
                                                        },
                                                    }));
                                                }}
                                                showErrorMessage={this.showErrorMessage}
                                                addressLocation={this.state.element?.projectAddress}
                                                countries={this.state.countries}
                                                validator={this.validator}
                                                viewMode={this.props.viewMode}
                                                handleChange={this.handleChange}
                                                customAddressLabel='Adres inny niż adres klienta'
                                                supportCustomAddress={true}
                                                addressIsCustom={this.state.projectAddressIsCustom}
                                                baseAddress={this.state?.element?.client?.address}
                                                baseLocation={this.state?.element.client?.location}
                                                />}
                                        </Card>
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel header={t('project.details.detailsTabHeader')}>
                                <div className='row profile'>
                                    <div className='col-12 col-xs-12 col-sm-12 col-md-12 details-card-wrapper' >
                                        {this.extraWorkEnabled ? (
                                            <Card header={t('project.details.activities')} className='data-card'>
                                                <DivContainer colClass='row'>
                                                    <DataTable value={this.state.element?.activities} responsiveLayout="scroll" emptyMessage={t('list.empty')}>
                                                        <Column field="activity" header="Aktywność" body={this.projectActivityActivityTemplate.bind(this)}></Column>
                                                        <Column field="price" header="Cena/h" body={this.projectActivityPriceTemplate.bind(this)}></Column>
                                                        {this.props.viewMode != 'VIEW' ? (
                                                            <Column header="" body={this.projectActivityActionsTemplate.bind(this)}></Column>
                                                        ) : null}
                                                    </DataTable>
                                                </DivContainer>
                                                <DivContainer>
                                                    <ActionLink
                                                        label={t('project.details.addActivityButton')}
                                                        iconName='mdi-plus'
                                                        iconSide='left'
                                                        iconSize='icon-large'
                                                        variant='blue'
                                                        className='float-right'
                                                        key={'add-activity-button'}
                                                        handleClick={this.handleAddNewProjectActivity.bind(this)}
                                                        rendered={this.props.viewMode !== 'VIEW'}
                                                    />
                                                </DivContainer>
                                            </Card>
                                        ) : null }
                                    </div>

                                    <div className='col-12 col-xs-12 col-sm-12 col-md-12 details-card-wrapper' >
                                        {this.state.activitiesForTimeReporting?.length > 0  ?
                                            <Card header={t('project.details.activitiesTimeReporting')} className='data-card'>
                                                <DivContainer colClass='row'>
                                                    <DataTable value={this.state.element?.activitiesForTimeReporting} responsiveLayout="scroll" emptyMessage={t('list.empty')}>
                                                        <Column field="activity" header="Aktywność" body={this.projectActivityForTimeReportingActivityTemplate.bind(this)}></Column>
                                                        {this.props.viewMode != 'VIEW' ? (
                                                            <Column header="" body={this.projectActivityTimeReportingActionsTemplate.bind(this)}></Column>
                                                        ) : null}
                                                    </DataTable>
                                                </DivContainer>
                                                <DivContainer>
                                                    <ActionLink
                                                        label={t('project.details.addActivityButton')}
                                                        iconName='mdi-plus'
                                                        iconSide='left'
                                                        iconSize='icon-large'
                                                        variant='blue'
                                                        className='float-right'
                                                        key={'add-activity-button'}
                                                        handleClick={this.handleAddNewProjectTimeReportingActivity.bind(this)}
                                                        rendered={this.props.viewMode !== 'VIEW'}
                                                    />
                                                </DivContainer>
                                            </Card> : null
                                        }
                                    </div>
                                    <div className='col-12 col-xs-12 col-sm-12 col-md-12 details-card-wrapper'>
                                        {this.carEnabled ? (
                                            <Card header={t('project.details.cars')} className='data-card'>
                                                <DivContainer colClass='row'>
                                                    <DataTable value={this.state.element?.projectCars} id="cars-list" responsiveLayout="scroll" emptyMessage={t('list.empty')}>
                                                        <Column field="car" header="Pojazd" body={this.carTemplate.bind(this)}></Column>
                                                        <Column field="dateStart" header="Od" body={this.carStartDateTemplate.bind(this)}></Column>
                                                        <Column field="dateEnd" header="Do" body={this.carEndDateTemplate.bind(this)}></Column>
                                                        {this.props.viewMode != 'VIEW' ? (
                                                            <Column header="" body={this.carActionsTemplate.bind(this)}></Column>
                                                        ) : null}
                                                    </DataTable>
                                                </DivContainer>
                                                <DivContainer rendered={this.props.viewMode != 'VIEW'}>
                                                    <ActionLink
                                                        label={t('project.details.addCarButton')}
                                                        iconName='mdi-plus'
                                                        iconSide='left'
                                                        iconSize='icon-large'
                                                        variant='blue'
                                                        className='float-right'
                                                        key={'add-activity-button'}
                                                        handleClick={this.handleAddNewCar.bind(this)}
                                                    />
                                                </DivContainer>
                                            </Card>
                                        ) : null}
                                    </div>
                                    <div className='col-12 col-xs-12 col-sm-12 col-md-12 details-card-wrapper'>
                                        {this.toolboxEnabled ? (
                                            <Card header={t('project.details.tools')} className='data-card'>
                                                <DivContainer colClass='row'>
                                                    <DataTable value={this.state.element.tools} id='tools-list' responsiveLayout="scroll" emptyMessage={t('list.empty')}>
                                                        <Column field="activity" header="Zestaw" body={this.projectToolsToolsTemplate.bind(this)}></Column>
                                                        <Column field="owner" header="Właściciel" body={this.projectToolsOwnerTemplate.bind(this)}></Column>
                                                        <Column field="car" header="Pojazd" body={this.projectToolsCarTemplate.bind(this)}></Column>
                                                        {this.props.viewMode != 'VIEW' ? (
                                                            <Column header="" body={this.projectToolsActionsTemplate.bind(this)}></Column>
                                                        ) : null}

                                                    </DataTable>
                                                </DivContainer>
                                                <DivContainer rendered={this.props.viewMode != 'VIEW'}>
                                                    <ActionLink
                                                        label={t('project.details.addToolsButton')}
                                                        iconName='mdi-plus'
                                                        iconSide='left'
                                                        iconSize='icon-large'
                                                        variant='blue'
                                                        className='float-right'
                                                        key={'add-activity-button'}
                                                        handleClick={this.handleAddNewTools.bind(this)}
                                                    />
                                                </DivContainer>
                                            </Card>
                                        ) : null}
                                    </div>
                                </div>
                            </TabPanel>


                            <TabPanel header={t('project.details.teamTabHeader')}>
                                <div className='row profile'>
                                    <div className='col-12 col-xs-12 col-sm-12 col-md-12 details-card-wrapper' >
                                        <Card header={t('project.details.employees')} className='data-card'>
                                            <DivContainer colClass='row'>
                                                <DataTable id='project-team-table' value={this.state.element?.users} responsiveLayout="scroll" emptyMessage={t('list.empty')} className='project-team-table'>
                                                    <Column field="employee" header="Pracownik" body={this.projectUserTemplate.bind(this)}></Column>
                                                    <Column field="dateStart" header="Od" body={this.projectUserStartTemplate.bind(this)}></Column>
                                                    <Column field="dateTo" header="Do" body={this.projectUserEndTemplate.bind(this)}></Column>
                                                    {rolePm || roleSupervisor ? (
                                                        <Column field="info" header="Status" body={this.projectUserStatisticTemplate.bind(this)}></Column>
                                                    ) : null}
                                                    {this.props.viewMode != 'VIEW' ? (
                                                        <Column header="" body={this.projectUserActionsTemplate.bind(this)}></Column>
                                                    ) : null}
                                                </DataTable>
                                            </DivContainer>
                                            <DivContainer rendered={this.props.viewMode != 'VIEW'}>
                                                <ActionLink
                                                    label={t('project.details.addEmployeeButton')}
                                                    iconName='mdi-plus'
                                                    iconSide='left'
                                                    iconSize='icon-large'
                                                    variant='blue'
                                                    className='float-right'
                                                    key={'add-activity-button'}
                                                    handleClick={this.handleAddNewProjectUser.bind(this)}
                                                />
                                            </DivContainer>
                                        </Card>
                                    </div>
                                    <div className='col-12 col-xs-12 col-sm-12 col-md-12 details-card-wrapper' >
                                        {this.authService.getProfile().hideLeadersAndManagers === true ? null :
                                            <Card header={t('project.details.leaders')} className='data-card'>
                                                <DivContainer colClass='row'>
                                                    <DataTable value={this.state.element?.managers} responsiveLayout="scroll" emptyMessage={t('list.empty')} className='project-team-table'>
                                                        <Column field="employee" header="Lider" body={this.projectManagerTemplate.bind(this)}></Column>
                                                        <Column field="from" header="Od" body={this.projectManagerStartTemplate.bind(this)}></Column>
                                                        <Column field="price" header="Do" body={this.projectManagerEndTemplate.bind(this)}></Column>
                                                        <Column field="leaderType" header="Typ" body={this.projectManagerTypeTemplate.bind(this)}></Column>
                                                        <Column field="info" header="Status" body={this.projectManagerStatisticTemplate.bind(this)}></Column>
                                                        {this.props.viewMode != 'VIEW' ? (
                                                            <Column header="" body={this.projectManagerActionsTemplate.bind(this)}></Column>
                                                        ) : null}
                                                    </DataTable>
                                                </DivContainer>
                                                <DivContainer rendered={this.props.viewMode != 'VIEW'}>
                                                    <ActionLink
                                                        label={t('project.details.addLeaderButton')}
                                                        iconName='mdi-plus'
                                                        iconSide='left'
                                                        iconSize='icon-large'
                                                        variant='blue'
                                                        className='float-right'
                                                        key={'add-activity-button'}
                                                        handleClick={this.handleAddNewProjectManager.bind(this)}
                                                    />
                                                </DivContainer>
                                            </Card>
                                        }
                                    </div>
                                    <div className='col-12 col-xs-12 col-sm-12 col-md-12 details-card-wrapper' >
                                        {this.authService.getProfile().hideLeadersAndManagers === true ? null :
                                            <Card header={t('project.details.managers')} className='data-card'>
                                                <DivContainer colClass='row'>
                                                    <div className="col-md-6">
                                                        <InputDropdownComponent
                                                            id={`projectManager`}
                                                            name="projectManager"
                                                            label={t('project.details.projectManager')}
                                                            value={this.state.element.projectManager}
                                                            valueView={this.state.element?.projectManager?.fullName}
                                                            dataKey='id'
                                                            options={this.state.projectManagers}
                                                            optionLabel='fullName'
                                                            viewMode={this.props.viewMode}
                                                            validator={this.validator}
                                                            validators='not_required'
                                                            onChange={this.handleChange}
                                                            insideTable
                                                            filter
                                                            filterBy="fullName"
                                                            showClear
                                                        />
                                                    </div>
                                                </DivContainer>
                                                <DivContainer colClass='row' rendered={this.projectExternalSupervisorEnabled}>
                                                    <div className="col-md-6">
                                                        <InputDropdownComponent
                                                            id={`externalSupervisor`}
                                                            name="externalSupervisor"
                                                            label={t('project.details.externalSupervisor')}
                                                            value={this.state.element.externalSupervisor}
                                                            valueView={this.state.element?.externalSupervisor?.fullName}
                                                            dataKey='id'
                                                            options={this.state.externalSupervisors}
                                                            optionLabel='fullName'
                                                            viewMode={this.props.viewMode}
                                                            validator={this.validator}
                                                            validators='not_required'
                                                            onChange={this.handleChange}
                                                            insideTable
                                                            filter
                                                            filterBy="fullName"
                                                            showClear
                                                        />
                                                    </div>
                                                </DivContainer>
                                                <DivContainer colClass='row' rendered={this.projectSupervisorEnabled}>
                                                    <div className="col-md-6">
                                                        <InputDropdownComponent
                                                            id={`supervisor`}
                                                            name="supervisor"
                                                            label={t('project.details.supervisor')}
                                                            value={this.state.element.supervisor}
                                                            valueView={this.state.element?.supervisor?.fullName}
                                                            dataKey='id'
                                                            options={this.state.supervisors}
                                                            optionLabel='fullName'
                                                            viewMode={this.props.viewMode}
                                                            validator={this.validator}
                                                            validators='not_required'
                                                            onChange={this.handleChange}
                                                            insideTable
                                                            filter
                                                            filterBy="fullName"
                                                            showClear
                                                        />
                                                    </div>
                                                </DivContainer>
                                                <DivContainer colClass='row' rendered={this.projectExternalManagerEnabled}>
                                                    <div className="col-md-6">
                                                        <InputDropdownComponent
                                                            id={`externalManager`}
                                                            name="externalManager"
                                                            label={t('project.details.externalManager')}
                                                            value={this.state.element.externalManager}
                                                            valueView={this.state.element?.externalManager?.fullName}
                                                            dataKey='id'
                                                            options={this.state.externalManagers}
                                                            optionLabel='fullName'
                                                            viewMode={this.props.viewMode}
                                                            validator={this.validator}
                                                            validators='not_required'
                                                            onChange={this.handleChange}
                                                            insideTable
                                                            filter
                                                            filterBy="fullName"
                                                            showClear
                                                            disabled={roleExternalManager && !roleAdmin}
                                                        />
                                                    </div>
                                                </DivContainer>
                                            </Card>
                                        }
                                    </div>
                                </div>

                            </TabPanel>

                            <TabPanel header={t('project.details.expansesTabHeader')}>
                                <div className='row profile'>
                                    <div className='col-12 col-xs-12 col-sm-12 col-md-12 details-card-wrapper' >                                        
                                        {this.state.element.id ? (
                                            <ProjectExpensesContainer
                                                validator={this.validator}
                                                expenses={this.state.element.expenses}
                                                projectId={this.state.element.id}
                                                onProjectChanged={(project) => {
                                                    this.updateElement(project)
                                                }}
                                                blockUi={this.blockUi}
                                                unblockUi={this.unblockUi}
                                            />
                                        ) : (
                                            <Card className='data-card'>{t('global.availabilityAfterSaveProject')}</Card>
                                        )}
                                    </div>
                                </div>

                            </TabPanel>

                            {(rolePm || roleSupervisor) && this.extraWorkEnabled ? (
                                <TabPanel header={t('project.details.extraEventTabHeader')}>
                                    <div className='row profile'>
                                        <div className='col-12 col-xs-12 col-sm-12 col-md-12 details-card-wrapper' >
                                            {this.state.element.id ? (
                                                <ProjectExtraEventListContainer
                                                    validator={this.validator}
                                                    projectId={this.state.element.id}
                                                    onProjectChanged={(project) => {
                                                        this.updateElement(project)
                                                    }}
                                                    viewClassname='data-card list-data-card'
                                                />
                                            ) : (
                                                <Card className='data-card'>{t('global.availabilityAfterSaveProject')}</Card>
                                            )}
                                        </div>
                                    </div>
                                </TabPanel>
                            ) : null}

                            <TabPanel header={t('project.details.summaryTabHeader')}>
                                <div className='row profile'>
                                    <div className='col-12 col-xs-12 col-sm-12 col-md-6 details-card-wrapper'>
                                        <Card className='data-card' 
                                            header={() => {
                                                return (
                                                    <div className='card-header-with-icon-container'>
                                                        <i className='mdi mdi-cash-plus'/>
                                                        <span>{t('project.details.revenue')}</span>
                                                    </div>
                                                )
                                            }}>
                                            <DivContainer colClass='row'>
                                                <InputDropdownComponent
                                                    id='priceType'
                                                    name='priceType'
                                                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                                                    label={t('project.details.priceType')}
                                                    value={this.state.element?.summary?.priceType}
                                                    stateField='element.summary'
                                                    dataKey='enumValue'
                                                    options={this.state.priceTypes}
                                                    optionLabel='label'
                                                    viewMode={roleFinanceAccess ? this.props.viewMode : 'VIEW'}
                                                    viewValue={this.state?.element?.summary?.priceType?.label}
                                                    validator={this.validator}
                                                    validators='not_required'
                                                    onChange={this.handleChange}
                                                    onAfterStateChange={this.calculateRevenue}
                                                    rendered={this.props.viewMode !== 'VIEW' || this.state.element?.summary?.priceType?.enumValue != undefined}
                                                />
                                                <InputTextComponent 
                                                    id='priceTypeEmpty'
                                                    colClass='col-xl-6 col-lg-6 col-md-6 col-sm-6'
                                                    label={t('project.details.priceType')}
                                                    value={t('project.details.notSet')}
                                                    rendered={this.props.viewMode === 'VIEW' && !this.state.element?.summary?.priceType?.enumValue}
                                                />
                                                {roleFinanceAccess ? ( 
                                                    <>
                                                        <div className='col-xl-6 col-lg-6 col-md-6 col-sm-6'>
                                                            <InputCheckboxComponent 
                                                                id='samePriceForAll'
                                                                name='samePriceForAll'
                                                                label={this.state.element?.summary?.priceType?.enumValue === 'PER_MONTH' ? t('project.details.priceTypeEqualForAllMonths') : t('project.details.priceTypeEqualForAllUsers')}
                                                                colClass='col-md-12'
                                                                viewMode={this.props.viewMode}
                                                                value={this.state.element?.summary?.samePriceForAll}
                                                                onChange={this.handleChange}
                                                                stateField='element.summary'
                                                                rendered={this.state.element?.summary?.priceType?.enumValue === 'PER_HOUR' || this.state.element?.summary?.priceType?.enumValue === 'PER_MONTH'}
                                                            />

                                                            <InputNumberComponent
                                                                id='unitPriceValue'
                                                                name='value'
                                                                colClass='col-md-12'
                                                                label={this.summaryUnitPriceLabel(this.state.element?.summary?.priceType)}                                                            
                                                                value={this.state.element.summary?.unitPrice?.value}
                                                                stateField='element.summary.unitPrice'
                                                                onChange={this.handleChange}
                                                                viewMode={this.props.viewMode}
                                                                validator={this.validator}
                                                                validators='not_required'
                                                                onAfterStateChange={this.calculateRevenue}
                                                                mode='currency'
                                                                currency='PLN'
                                                                locale='pl-PL'
                                                                rendered={this.state.element?.summary?.priceType?.enumValue !== undefined 
                                                                    && !((this.state.element?.summary?.priceType?.enumValue === 'PER_HOUR' || this.state.element?.summary?.priceType?.enumValue === 'PER_MONTH') 
                                                                        && !this.state.element?.summary?.samePriceForAll)
                                                                }
                                                            />
                                                            {this.state.element?.summary?.priceType?.enumValue === 'PER_HOUR' && !this.state.element?.summary?.samePriceForAll ? (
                                                                <Message text={t('project.details.priceTypePerHourNotSameForAllInfo')} />
                                                            ) : null}
                                                        </div>
                                                        {this.state.element?.summary?.priceType?.enumValue === 'PER_MONTH' && !this.state.element?.summary?.samePriceForAll ? (
                                                            <>
                                                            <div className='col-md-12'>
                                                                <div className='row'>
                                                                    <div className='form-group'>
                                                                        <label className='p-label'>{t('project.details.monthScheduleLabel')}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-12'>
                                                                {/* tabelka jest tylko po to, zeby zobaczyć efekt na ui */}
                                                                <DataTable
                                                                    id='monthSchedule'
                                                                    value={this.state.element?.summary?.monthSchedule}
                                                                    responsiveLayout='scroll'
                                                                    emptyMessage={t('list.empty')}
                                                                >
                                                                    <Column
                                                                        field='dateFrom'
                                                                        header={t('employee.details.dateFrom')}
                                                                        body={(item, column) => {
                                                                            const rowIndex = column.rowIndex;
                                                                            return (
                                                                                        <div style={{ minWidth: '120px', maxWidth: '200px' }}>
                                                                                            <InputCalendarComponent
                                                                                                id={`monthSchedule${rowIndex}`}
                                                                                                name='dateFrom'
                                                                                                value={item.dateFrom}
                                                                                                stateField={`element.summary.monthSchedule[${rowIndex}]`}
                                                                                                showLabel={false}
                                                                                                onChange={this.handleChange}
                                                                                                insideTable
                                                                                                viewMode={this.props.viewMode}
                                                                                                // viewMode={canEdit ? this.props.viewMode : 'VIEW'}
                                                                                                validator={this.validator}
                                                                                                validators='required'
                                                                                                // disabled={disabled}
                                                                                                // minDate={(disabled || this.state.element?.contracts.length === 1)
                                                                                                //     ? null : this.calculateMinDateForDateFrom(rowIndex)}
                                                                                                // maxDate={this.calculateMaxDateForDateFrom(rowIndex)}
                                                                                                showClear
                                                                                                // onAfterStateChange={() => {
                                                                                                //     this.setContractsDatesTo();
                                                                                                // }}
                                                                                                dateFormatMoment={this.monthScheduleDateConfig.dateFormatMoment}
                                                                                                view={this.monthScheduleDateConfig.view}
                                                                                                dateFormat={this.monthScheduleDateConfig.dateFormat}
                                                                                                placeholder={this.monthScheduleDateConfig.placeholder}
                                                                                                yearNavigator={this.monthScheduleDateConfig.yearNavigator}
                                                                                                showIcon
                                                                                            />
                                                                                        </div>
                                                                                    );
                                                                        }}
                                                                    />
                                                                    <Column
                                                                        field='dateTo'
                                                                        header={t('employee.details.dateTo')}
                                                                        body={(item, column) => {
                                                                            const rowIndex = column.rowIndex;
                                                                            return (
                                                                                        <div style={{ minWidth: '120px', maxWidth: '200px' }}>
                                                                                            <InputCalendarComponent
                                                                                                id={`monthSchedule${rowIndex}`}
                                                                                                name='dateFrom'
                                                                                                value={item.dateFrom}
                                                                                                stateField={`element.summary.monthSchedule[${rowIndex}]`}
                                                                                                showLabel={false}
                                                                                                onChange={this.handleChange}
                                                                                                insideTable
                                                                                                viewMode={this.props.viewMode}
                                                                                                // viewMode={canEdit ? this.props.viewMode : 'VIEW'}
                                                                                                validator={this.validator}
                                                                                                validators='required'
                                                                                                // disabled={disabled}
                                                                                                // minDate={(disabled || this.state.element?.contracts.length === 1)
                                                                                                //     ? null : this.calculateMinDateForDateFrom(rowIndex)}
                                                                                                // maxDate={this.calculateMaxDateForDateFrom(rowIndex)}
                                                                                                showClear
                                                                                                // onAfterStateChange={() => {
                                                                                                //     this.setContractsDatesTo();
                                                                                                // }}
                                                                                                dateFormatMoment={this.monthScheduleDateConfig.dateFormatMoment}
                                                                                                view={this.monthScheduleDateConfig.view}
                                                                                                dateFormat={this.monthScheduleDateConfig.dateFormat}
                                                                                                placeholder={this.monthScheduleDateConfig.placeholder}
                                                                                                yearNavigator={this.monthScheduleDateConfig.yearNavigator}
                                                                                                showIcon
                                                                                            />
                                                                                        </div>
                                                                                    );
                                                                        }}
                                                                    />
                                                                    <Column
                                                                            field='cost.value'
                                                                            header={t('employee.details.cost')}
                                                                            body={(rowData, props) => {
                                                                                    const rowIndex = props.rowIndex;
                                                                                    return (
                                                                                        <InputNumberComponent
                                                                                            id={`contractCost${rowIndex}`}
                                                                                            name='value'
                                                                                            label={t('employee.details.cost')}
                                                                                            value={rowData.value?.value}
                                                                                            stateField={`element.contracts[${rowIndex}].cost`}
                                                                                            showLabel={false}
                                                                                            onChange={this.handleChange}
                                                                                            insideTable
                                                                                            viewMode={this.props.viewMode}
                                                                                            validator={this.validator}
                                                                                            validators='required'
                                                                                            mode='currency'
                                                                                            currency='PLN'
                                                                                            locale='pl-PL'
                                                                                        />
                                                                                    );
                                                                                }
                                                                            }
                                                                    />
                                                                </DataTable>

                                                            </div> 
                                                            </>                                                    
                                                        ) : null}
                                                    </>
                                                ): null}
                                            </DivContainer>
                                            <DivContainer colClass='row' rendered={this.supportedPriceType?.indexOf('KWP') >= 0 || this.supportedPriceType?.indexOf('PANEL') >= 0}>
                                                {this.state.element?.summary?.priceType?.enumValue === 'KWP' ?  summaryPanelNumber() : summaryKwpNumber()}
                                                {this.state.element?.summary?.priceType?.enumValue === 'KWP' ?  summaryKwpNumber() : summaryPanelNumber()}
                                            </DivContainer>

                                            {this.extraWorkEnabled && roleFinanceAccess ? (
                                                <React.Fragment>
                                                    <div className="separator-horizontal"></div>
                                                    
                                                    <DivContainer colClass='row'>
                                                        <div className='col-md-4 summary-label'>
                                                            <label>{t('project.details.mainRevenue')}</label>
                                                        </div>
                                                        <div className="col-md-8 summary-value">
                                                            <span>{CurrencyUtils.format(this.state.element.summary?.revenueEmployees?.value, 'PLN')}</span>
                                                        </div>
                                                    </DivContainer>
                                                    <DivContainer colClass='row' rendered={this.extraWorkEnabled}>
                                                        <div className='col-md-4 summary-label'>
                                                            <label>{t('project.details.extraRevenue')}</label>
                                                        </div>
                                                        <div className="col-md-4 summary-value">
                                                            <span>{NumberUtils.formatTimeIfPossible(this.state.element?.summary?.hoursExtra, '00:00')} h</span>
                                                        </div>
                                                        <div className="col-md-4 summary-value">
                                                            <span>{CurrencyUtils.format(this.state.element?.summary?.revenueExtra?.value, 'PLN')}</span>
                                                        </div>
                                                    </DivContainer>
                                                </React.Fragment>
                                            ) : null}
                                            {roleFinanceAccess ? (
                                                <>
                                                    <div className="separator-horizontal"></div>
                                                    <div className="row">
                                                        <div className="col-md-12 summary-value">
                                                            <span>{CurrencyUtils.format(this.state.element.summary?.revenueTotal?.value, 'PLN')}</span>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : null }
                                        </Card>
                                    </div>
                                    {!roleFinanceAccess ? (
                                        <div className='col-12 col-xs-12 col-sm-12 col-md-6 details-card-wrapper'>
                                            <Card className='data-card' 
                                                header={() => {
                                                    return (
                                                    <div className='card-header-with-icon-container'>
                                                        <i className='mdi mdi-bank'/>
                                                        <span>{t('project.details.timesheet')}</span>
                                                    </div>
                                                )
                                            }}>                                            
                                                <DivContainer colClass='row'>
                                                    <DivContainer colClass='col-md-10'>
                                                        <DivContainer colClass="row">
                                                            <InputTextComponent
                                                                colClass="col-md-4"
                                                                label='Zaraportowane godziny pracy'
                                                                viewMode='EDIT'
                                                                disabled
                                                                value={NumberUtils.formatTimeIfPossible(this.state.element?.summary?.hoursEmployees)}
                                                                format='number'
                                                                id='view-hoursEmployees'
                                                            />
                                                            <InputTextComponent
                                                                colClass="col-md-4"
                                                                label='Zaraportowane godziny pracy kierowcy'
                                                                viewMode='EDIT'
                                                                disabled
                                                                value={NumberUtils.formatTimeIfPossible(this.state.element?.summary?.hoursDrivers)}
                                                                format='number'
                                                                id='view-hoursDrivers'
                                                            />
                                                            <InputTextComponent
                                                                colClass="col-md-4"
                                                                label='Zatwierdzone godziny pracy dodatkowej'
                                                                viewMode='EDIT'
                                                                disabled
                                                                value={NumberUtils.formatTimeIfPossible(this.state.element?.summary?.hoursExtra)}
                                                                format='number'
                                                                id='view-hoursDrivers'
                                                            />
                                                        </DivContainer>
                                                    </DivContainer>
                                                </DivContainer>
                                            </Card>
                                        </div>
                                    ) : null}
                                    {roleFinanceAccess ? (
                                     <>   
                                        <div className='col-12 col-xs-12 col-sm-12 col-md-6 details-card-wrapper' >
                                            <Card className='data-card'
                                                header={() => {
                                                    return (
                                                        <div className='card-header-with-icon-container'>
                                                            <i className='mdi mdi-cash-minus'/>
                                                            <span>{t('project.details.cost')}</span>
                                                        </div>
                                                    )
                                                }}>
                                                <DivContainer colClass='row'>
                                                    <div className='col-md-4 summary-label'>
                                                        <label>{t('project.details.costEmployees')}</label>
                                                    </div>
                                                    <div className="col-md-4 summary-value">
                                                        <span>{NumberUtils.formatTimeIfPossible(hoursEmployees, '00:00')} h</span>
                                                    </div>
                                                    <div className="col-md-4 summary-value">
                                                        <span>{CurrencyUtils.format(costEmployees, 'PLN')}</span>
                                                    </div>
                                                </DivContainer>
                                                <DivContainer colClass='row' rendered={this.allowGroupTimeReporting}>
                                                    <div className='col-md-4 summary-label'>
                                                        <label>{t('project.details.costDrivePriceTotal')}</label>
                                                    </div>
                                                    <div className="col-md-4 summary-value">
                                                        <span>{NumberUtils.formatTimeIfPossible(this.state.element?.summary?.hoursDrivers, '00:00')} h</span>
                                                    </div>
                                                    <div className="col-md-4 summary-value">
                                                        <span>{CurrencyUtils.format(this.state.element?.summary?.costDrivers?.value, 'PLN')}</span>
                                                    </div>
                                                </DivContainer>
                                                <DivContainer colClass='row' rendered={this.projectSettlementCostPresentationStrategy === 'SEPARATED'}>
                                                    <div className='col-md-4 summary-label'>
                                                        <label>{t('project.details.costOfficeEmployees')}</label>
                                                    </div>
                                                    <div className="col-md-4 summary-value">
                                                        <span>{NumberUtils.formatTimeIfPossible(this.state.element?.summary?.hoursOfficeEmployees, '00:00')} h</span>
                                                    </div>
                                                    <div className="col-md-4 summary-value">
                                                        <span>{CurrencyUtils.format(this.state.element?.summary?.costOfficeEmployees?.value, 'PLN')}</span>
                                                    </div>
                                                </DivContainer>
                                                <DivContainer colClass='row'>
                                                    <div className='col-md-4 summary-label'>
                                                        <label>{t('project.details.expences')}</label>
                                                    </div>
                                                    <div className="col-md-8 summary-value">
                                                        <span>{CurrencyUtils.format(this.state.element.summary?.costExpenses?.value, 'PLN')}</span>
                                                    </div>
                                                </DivContainer>
                                                <div className="separator-horizontal"></div>
                                                <div className="row">
                                                    
                                                    <div className="col-md-12 summary-value">
                                                        <span>{CurrencyUtils.format(this.state.element.summary?.costTotal?.value, 'PLN')}</span>
                                                    </div>
                                                </div>

                                            </Card>
                                        </div>
                                        <div className='col-12 col-xs-12 col-sm-12 col-md-6 details-card-wrapper' >
                                            <Card className='data-card' 
                                                header={() => {
                                                    return (
                                                        <div className='card-header-with-icon-container'>
                                                            <i className='mdi mdi-bank'/>
                                                            <span>{t('project.details.income')}</span>
                                                        </div>
                                                    )
                                                }}>
                                                <DivContainer colClass='row'>
                                                    
                                                    <div className="col-md-12 summary-value">
                                                        <span style={{
                                                            color: (this.state.element.summary?.income?.value >= 0 || !this.state.element.summary?.income?.value) ? 'green' : 'red', 
                                                            fontSize: '24px'}}>{CurrencyUtils.format(this.state.element.summary?.income?.value, 'PLN')}
                                                        </span>
                                                    </div>
                                                </DivContainer>

                                            </Card>
                                        </div>
                                    </>) : null }
                                </div>
                            </TabPanel>

                            


                            {(this.props.viewMode !== 'NEW') ? (
                                <TabPanel header={t('project.details.logsTabHeader')}>
                                    <div className='row profile'>
                                        <div className='col-12 col-xs-12 col-sm-12 col-md-12 details-card-wrapper' >
                                            <LogEntryListContainer
                                                objectType='PROJECT'
                                                objectId={this.props.elementId}
                                                expandFilters={false}
                                                renderHeader={false}
                                                viewClassname='data-card list-data-card'
                                            />
                                        </div>
                                    </div>
                                </TabPanel>
                            ) : null}
                        </TabView>
                    </DivContainer>
                    {this.props.viewMode !== 'NEW' ? (
                        <div>
                            <ExtraWorkProjectAggregationDialog
                                visible={this.state.extraWorkDialogVisible}
                                extras={this.state.extras}
                                onHide={() => { this.setState({ extraWorkDialogVisible: false }) }}
                            />
                            <ProjectWorkCostAggregationDialog
                                visible={this.state.workCostDialogVisible}
                                costs={this.state.workCosts}
                                onHide={() => { this.setState({ workCostDialogVisible: false }) }}
                            />
                            <ProjectDriveCostAggregationDialog
                                visible={this.state.driveCostDialogVisible}
                                costs={this.state.driveCosts}
                                onHide={() => { this.setState({ driveCostDialogVisible: false }) }}
                            />
                        </div>
                    ) : null}
                </DivContainer>
                {this.state.showConfirmCloseProject && this.state.element.id && this.renderClosePojectComponent()}
            </React.Fragment>
        )
    }


    summaryUnitPriceLabel(priceType) {
        const v = priceType?.enumValue;
        switch (v) {
            case 'PANEL': return t('project.details.priceTypePanelLabel');
            case 'KWP': return t('project.details.priceTypeKwpLabel');
            case 'FIXPRICE': return t('project.details.priceTypeFixPriceLabel');
            case 'PER_HOUR': return t('project.details.priceTypePerHourLabel');
            case 'PER_MONTH': return t('project.details.priceTypePerMonthLabel'); 
        }
        return "-";
    }

    renderClosePojectComponent() {
        return (
            <YesNoDialog
                visible={this.state.showConfirmCloseProject}
                header={t('project.closeConfirm')}
                name='visible'
                childrenHide
                onChange={(a, b, target) => {
                    if (target.value) {
                        this.blockUi();
                        this.service
                            .closeProject(this.state.element.id)
                            .then(() => {
                                window.location.href = this.navigationContext.addNavigationContextToUrl(this.props.backUrl);
                            })
                            .catch((error) => {
                                this.showErrorMessage(error.message);
                            })
                            .finally(() => {
                                this.unblockUi();
                                this.setState({
                                    showConfirmCloseProject: false,
                                });
                            });
                    } else {
                        this.setState({ showConfirmCloseProject: false });
                    }
                }}
                onHide={() => {
                    this.setState({ showConfirmCloseProject: false });
                }}
            ></YesNoDialog>
        );
    }

    showExtraDetails() {
        if (this.props.viewMode === 'NEW') {
            return;
        }
        this.service.getExtraWorkAggregation(this.state.element.id)
            .then(extras => this.setState({ extras, extraWorkDialogVisible: true }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać agregacji zatwierdzonych prac dodatkowych');
            });
    }

    showWorkCosts() {
        if (this.props.viewMode === 'NEW') {
            return;
        }
        this.service.getWorkCostAggregation(this.state.element.id)
            .then(workCosts => this.setState({ workCosts, workCostDialogVisible: true }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy kosztów pracowników w podziale na stawki');
            });
    }
    showOfficeEmployeeWorkCosts() {
        if (this.props.viewMode === 'NEW') {
            return;
        }
        this.service.getOfficeEmployeeWorkCostAggregation(this.state.element.id)
            .then(workCosts => this.setState({ workCosts, workCostDialogVisible: true }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy kosztów pracowników biurowych w podziale na stawki');
            });
    }


    showDriveCosts() {
        if (this.props.viewMode === 'NEW') {
            return;
        }
        this.service.getDriveCostAggregation(this.state.element.id)
            .then(driveCosts => this.setState({ driveCosts, driveCostDialogVisible: true }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy kosztów kierowców w podziale na stawki');
            });
    }

    calculateTotalRevenue(data) {
        let total = 0;
        if (data?.summary?.revenueExtra?.value) {
            total += parseFloat(data?.summary?.revenueExtra?.value);
        }

        if (data?.summary?.revenueEmployees?.value) {
            total += parseFloat(data.summary.revenueEmployees.value);
        }
        return total;
    }

    calculateIncome() {
        let income = 0;
        if (this.state.element?.summary?.revenueTotal?.value) {
            income = parseFloat(this.state.element.summary.revenueTotal?.value);
        }
        if (this.state.element?.summary?.costTotal?.value) {
            income = income - parseFloat(this.state.element.summary.costTotal.value);
        }
        const summary = this.state.element.summary;
        summary.income.value = income;
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                summary,
            },
        }));
        return income;
    }

    calculateTotalCost(data) {
        let totalCost = 0;
        if (data.summary.employeesCost.totalPrice) {
            totalCost += parseFloat(data.summary.employeesCost.totalPrice);
        }
        if (data.summary.expensesTotal && data.summary.expensesTotal.value) {
            totalCost += parseFloat(data.summary.expensesTotal.value);
        }
        return totalCost;
    }

    calculateRevenue() {
        let unitPrice = this.state.element?.summary?.unitPrice?.value;
        let hours = 0;
        if (NumberUtils.isNumber(this.state.element?.summary?.hoursEmployees)) {
            hours += this.state.element?.summary?.hoursEmployees;
        }
        if (NumberUtils.isNumber(this.state.element?.summary?.hoursOfficeEmployees)) {
            hours += this.state.element?.summary?.hoursOfficeEmployees;
        }
        const priceType = this.state.element?.summary?.priceType;
        const { panelNumber, kwpNumber } = this.state.element;
        let revenue = null;
        if (unitPrice && priceType) {
            if (priceType?.enumValue === 'KWP' && kwpNumber) {
                revenue = kwpNumber.toString().replaceAll(',', '.').replaceAll(' ', '') * unitPrice.toString().replaceAll(',', '.');
            } else if (priceType?.enumValue === 'PANEL' && panelNumber) {
                revenue = panelNumber.toString().replaceAll(',', '.').replaceAll(' ', '') * unitPrice.toString().replaceAll(',', '.');
            } else if (priceType?.enumValue === 'FIXPRICE') {
                revenue = unitPrice.toString().replaceAll(',', '.');
            } else if (priceType?.enumValue === 'PER_HOUR') {
                revenue = NumberUtils.formatTimeAndMultiplyBy(hours, unitPrice.toString().replaceAll(',', '.').replaceAll(' ', ''));
            } else if (priceType?.enumValue === 'PER_MONTH') {
                revenue = this.calculateMonthlyRevenue(
                    unitPrice.toString().replaceAll(',', '.').replaceAll(' ', ''), 
                    this.state.element.dateStart,
                    this.state.element.dateEnd,
                    new Date()
                )
            }
            revenue = (Math.round(revenue * 100) / 100).toFixed(2);
        }
        const summary = this.state.element.summary;
        summary.revenueEmployees.value = revenue;
        summary.revenueTotal.value = this.calculateTotalRevenue(this.state.element);
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                summary,
            },
        }),
            () => this.calculateIncome()
        );
    }

    calculateMonthlyRevenue(monthlyRate, startDate, endDate, calculationDate) {        
        if (!startDate || !endDate) {
            return;
        }
        const start = startDate;
        const end = endDate;
        let calculation = calculationDate;
    
        // Sprawdzenie, czy data kalkulacji jest w zakresie umowy
        if (calculation < start) return 0; // Jeśli data obliczenia jest przed startem umowy, przychód wynosi 0
        if (calculation > end) calculation = end; // Jeśli data obliczenia jest po zakończeniu umowy, przypisz koniec umowy jako datę obliczenia
    
        // Zainicjuj przychód
        let revenue = 0;

        // Obliczenie pełnych miesięcy między początkowym i końcowym pełnym miesiącem umowy
        const fullStart = new Date(start.getFullYear(), start.getMonth() + 1, 1);
        const fullEnd = new Date(calculation.getFullYear(), calculation.getMonth(), 1);
        
        let months = (fullEnd.getFullYear() - fullStart.getFullYear()) * 12 + (fullEnd.getMonth() - fullStart.getMonth());
        
        // Dodaj przychód za pełne miesiące
        revenue += months * monthlyRate;
        
        // Dodaj przychód za niepełne miesiące na początku umowy
        
        const daysInStartMonth = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
        const chargeableDaysAtStart = daysInStartMonth - start.getDate() + 1;
        revenue += (chargeableDaysAtStart / daysInStartMonth) * monthlyRate;
        
        // // Dodaj przychód za niepełne miesiące na końcu umowy        
        //czy ostatni miesiąc umowy
        if (calculation.getFullYear() === endDate.getFullYear() && calculation.getMonth() === endDate.getMonth()) {
            const daysInEndMonth = new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate();
            const chargeableDaysAtEnd = end.getDate();
            revenue += (chargeableDaysAtEnd / daysInEndMonth) * monthlyRate;
        } else {
            revenue += Number(monthlyRate);
        }
        
        return revenue.toFixed(2);

    }

    //NARZĘDZIA
    projectToolsToolsTemplate(rowData, props) {
        const { rowIndex } = props;
        const ids = this.state.element.tools.map((x) => {
            if (x != null && x.tools != null) {
                return x.tools.id;
            }
        });
        const filteredList = this.state.tools.filter((x) => !ids.includes(x.id));
        return (
            <div style={{ minWidth: '300px' }}>
                <InputDropdownComponent
                    id={`tools${rowIndex}`}
                    name="tools"
                    value={rowData.tools}
                    stateField={`element.tools[${rowIndex}]`}
                    showLabel={false}
                    options={filteredList}
                    optionLabel='name'
                    onChange={this.handleChange}
                    insideTable
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators='required'
                    showClear
                    label={t('project.details.toolsPack')}
                    valueTemplate={this.toolsValueTemplate(rowData.tools)}
                    filter
                    filterBy={'name'}
                />
            </div>
        )
    }



    toolsValueTemplate(e) {
        if (e != null && e.name) {
            return <span style={{ color: 'black' }}>{e.name}</span>
        }
    }


    projectToolsOwnerTemplate(rowData, props) {
        const rowIndex = props.rowIndex;

        return (
            <div style={{ minWidth: '300px' }}>
                <InputAutocompleteComponent
                    id={`owner${rowIndex}`}
                    name="owner"
                    label={t('project.details.employee')}
                    value={rowData.owner}
                    dropdown
                    forceSelection
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators={`at_least_one_field_required:${rowIndex}`}
                    showLabel={false}
                    onChange={this.handleChange}
                    insideTable
                    filteredList={this.state.filteredEmployees}
                    filterList={query => this.searchEmployees(query)}
                    field="fullName"
                    minLength={3}
                    placeholder={t('search.users.placeholder')}
                    stateField={`element.tools[${rowIndex}]`}
                />
            </div>
        )
    }

    projectToolsCarTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <div style={{ minWidth: '300px' }}>
                <InputAutocompleteComponent
                    id={`car${rowIndex}`}
                    name="car"
                    label={t('project.details.car')}
                    value={rowData?.car}
                    dropdown
                    forceSelection
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators={`at_least_one_field_required:${rowIndex}`}
                    showLabel={false}
                    onChange={this.handleChange}
                    insideTable
                    showClear
                    filteredList={this.state.filteredCars}
                    filterList={query => this.searchCars(query)}
                    field="licensePlate"
                    minLength={3}
                    placeholder={t('search.cars.placeholder')}
                    stateField={`element.tools[${rowIndex}]`}
                />
            </div>
        )
    }

    projectToolsActionsTemplate(rowData) {
        return (
            <span>
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={(e) => {
                        let tools = this.state.element.tools.filter(t => t != rowData);
                        this.setState((prevState) => ({
                            element: {
                                ...prevState.element,
                                tools,
                            },
                        }));
                    }}
                    variant='blue'
                    className='edit-blue-link'
                    key={'delete-button'}
                />
            </span>
        );

    }

    handleAddNewTools() {
        const tools = this.state.element.tools;
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                tools: tools.concat({}),
            },
        }));
    }

    //NARZĘDZIA END

    //PRACOWNICY
    projectUserTemplate(rowData, props) {
        const { rowIndex } = props;
        const user = rowData;
        return (
            <div>
                <div className="category-icons" />
                <InputAutocompleteComponent
                    id={`employee${rowIndex}`}
                    name="employee"
                    colClass='col-md-7'
                    label={t('project.details.employee')}
                    value={user.employee}
                    dropdown
                    forceSelection
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators={`required|same_external_manager_for_user_and_project:${rowIndex},user|employee_local_assigment_duplicates:${rowIndex},user`}
                    showLabel={false}
                    onChange={this.handleChange}
                    insideTable={true}
                    filteredList={this.state.filteredEmployees}
                    filterList={query => this.searchEmployees(query, user?.employee?.id, 'users')}
                    field="fullName"
                    stateField={`element.users[${rowIndex}]`}
                    minLength={3}
                    placeholder={t('search.users.placeholder')}
                    onAfterStateChange={() => this.fetchUserStatisticAndHandleError(user, true)}
                />
                <div className="category-icons">
                    {this.inputColorComponent(rowData?.stats?.categories)}
                </div>
            </div>
        )
    }



    projectUserStartTemplate(rowData, props) {
        const { rowIndex } = props;
        const user = rowData;
        const { dateStart, dateEnd } = this.state.element;

        //min, max nie działa; gdy najpierw ustawiamy datę od na przyszły miesiąc, to nie można potem ustawić daty do (kontrolki są disabled); trzeba wtedy najpierw miesiąc zmienić i wrócić spowtotem
        //let minDate = dateStart;
        //let maxDate = dateEnd;
        //if (user.dateEnd && dateEnd && user.dateEnd.getTime() < dateEnd.getTime()) {
        //    maxDate = user.dateEnd;
        //} else if (user.dateEnd && (!minDate || minDate.getTime() > user.dateEnd.getTime())) {
        //    maxDate = user.dateEnd;
        //}

        return (
            <InputCalendarComponent
                id={`employeeDateStart${rowIndex}`}
                colClass='col-md-2'
                name="dateStart"
                label='Od'
                value={user.dateStart}
                onChange={this.handleChange}
                viewMode={this.props.viewMode}
                validator={this.validator}
                validators={`required|employee_assigment_date_range:${rowIndex},user|user_dates_in_project_range:${rowIndex},user,start`}
                stateField={`element.users[${rowIndex}]`}
                insideTable
                showLabel={false}
                showIcon
                //minDate={minDate}
                //maxDate={maxDate}
                onAfterStateChange={() => this.fetchUserStatisticAndHandleError(user, true)}
            />
        )
    }

    projectUserEndTemplate(rowData, props) {
        const { rowIndex } = props;
        const user = rowData;
        const { dateStart, dateEnd } = this.state.element;

        //min, max nie działa; gdy najpierw ustawiamy datę od na przyszły miesiąc, to nie można potem ustawić daty do (kontrolki są disabled); trzeba wtedy najpierw miesiąc zmienić i wrócić spowtotem
        // let minDate = dateStart;
        // let maxDate = dateEnd;
        // if (user.dateStart && dateStart && user.dateStart.getTime() > dateStart.getTime()) {
        //     minDate = user.dateStart;
        // } else if (user.dateStart && (!maxDate || maxDate.getTime() < user.dateStart.getTime())) {
        //     minDate = user.dateStart;
        // }
        return (
            <InputCalendarComponent
                id={`employeeDateEnd${rowIndex}`}
                colClass='col-md-2'
                name="dateEnd"
                label='Do'
                value={user.dateEnd}
                onChange={this.handleChange}
                viewMode={this.props.viewMode}
                validator={this.validator}
                validators={`required|employee_assigment_date_range:${rowIndex},user|user_dates_in_project_range:${rowIndex},user,end`}
                stateField={`element.users[${rowIndex}]`}
                insideTable
                showLabel={false}
                showIcon
                // minDate={minDate}
                // maxDate={maxDate}
                onAfterStateChange={() => this.fetchUserStatisticAndHandleError(user, true)}
            />
        )
    }

    

    projectUserStatisticTemplate(rowData, props) {
        const { rowIndex } = props;
        const user = rowData;
        const loading = user ? user.loadingStats : false;
        const render = user ? user.renderStats : false;
        return (
            <EmployeeProjectPlaningStatistic
                loading={loading}
                render={render}
                stats={user?.stats}
                user={user?.employee}
                showDetails={() => {
                    this.fetchUserStatistic(user, true)
                        .then(() => {
                            this.setState({
                                visibleEmployeeStatistic: true,
                                selectedEmployee: user?.employee,
                                selectedEmployeeStats: user?.stats,
                                selectedEmployeeDateStart: user?.dateStart,
                                selectedEmployeeDateEnd: user?.dateEnd
                            })
                        })
                        .catch(err => this.showErrorMessage(err))
                }
                }
            />
        )
    }



    projectUserActionsTemplate(rowData, props) {
        const { rowIndex } = props;
        const user = rowData;
        return (
            <div className="col-md-1 actions">
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    rendered={this.props.viewMode != 'VIEW'}
                    handleClick={(e) => {
                        let users = this.state.element.users.filter(u => u != user);
                        this.setState((prevState) => ({
                            element: {
                                ...prevState.element,
                                users,
                            },
                        }));
                    }}
                    variant='blue'
                    className='edit-blue-link'
                    key={'delete-button'}
                />
            </div>
        )
    }

    handleAddNewProjectUser() {
        const { users, dateStart, dateEnd } = this.state.element;
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                users: users.concat({ dateStart, dateEnd }),
            },
        }));
    }

    handleAddNewProjectManager() {
        const { managers, dateStart, dateEnd } = this.state.element;
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                managers: managers.concat({ dateStart, dateEnd }),
            },
        }));
    }


    projectManagerTemplate(rowData, props) {
        const { rowIndex } = props;
        const manager = rowData;
        return (
            <div>
                <div className="category-icons" />
                <InputAutocompleteComponent
                    id={`manager${rowIndex}`}
                    name="employee"
                    label={t('project.details.leader')}
                    value={manager.employee}
                    dropdown
                    forceSelection
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators={`required|same_external_manager_for_user_and_project:${rowIndex},manager|employee_local_assigment_duplicates:${rowIndex},manager`}
                    showLabel={false}
                    onChange={this.handleChange}
                    insideTable={true}
                    filteredList={this.state.filteredEmployees}
                    filterList={query => this.searchEmployees(query, manager?.employee?.id, 'managers')}
                    field="fullName"
                    stateField={`element.managers[${rowIndex}]`}
                    minLength={3}
                    placeholder={t('search.managers.placeholder')}
                    onAfterStateChange={() => this.fetchUserStatisticAndHandleError(manager, false)}
                />
                <div className="category-icons">
                    {rowData?.stats && this.inputColorComponent(rowData?.stats.categories)}
                </div>
            </div>
        )
    }

    projectManagerStartTemplate(rowData, props) {
        const { rowIndex } = props;
        const manager = rowData;
        const { dateStart, dateEnd } = this.state.element;

        //min, max nie działa; gdy najpierw ustawiamy datę od na przyszły miesiąc, to nie można potem ustawić daty do (kontrolki są disabled); trzeba wtedy najpierw miesiąc zmienić i wrócić spowtotem
        //let minDate = dateStart;
        //let maxDate = dateEnd;
        //if (manager.dateEnd && dateEnd && manager.dateEnd.getTime() < dateEnd.getTime()) {
        //   maxDate = manager.dateEnd;
        //}
        return (
            <InputCalendarComponent
                id={`managerDateStart${rowIndex}`}
                colClass='col-md-2'
                name="dateStart"
                label='Od'
                value={manager.dateStart}
                onChange={this.handleChange}
                viewMode={this.props.viewMode}
                validator={this.validator}
                validators={`required|employee_assigment_date_range:${rowIndex},manager|user_dates_in_project_range:${rowIndex},manager,start`}
                stateField={`element.managers[${rowIndex}]`}
                insideTable
                showLabel={false}
                showIcon
                //minDate={minDate}
                //maxDate={maxDate}
                onAfterStateChange={() => this.fetchUserStatisticAndHandleError(manager, false)}
            />
        )
    }

    projectManagerEndTemplate(rowData, props) {
        const { rowIndex } = props;
        const manager = rowData;
        const { dateStart, dateEnd } = this.state.element;
        //min, max nie działa; gdy najpierw ustawiamy datę od na przyszły miesiąc, to nie można potem ustawić daty do (kontrolki są disabled); trzeba wtedy najpierw miesiąc zmienić i wrócić spowtotem
        // let minDate = dateStart;
        // let maxDate = dateEnd;
        // if (manager.dateStart && dateStart && manager.dateStart.getTime() > dateStart.getTime()) {
        //     minDate = manager.dateStart;
        // }
        return (
            <InputCalendarComponent
                id={`managerDateEnd${rowIndex}`}
                colClass='col-md-2'
                name="dateEnd"
                label='Do'
                value={manager.dateEnd}
                onChange={this.handleChange}
                viewMode={this.props.viewMode}
                validator={this.validator}
                validators={`required|employee_assigment_date_range:${rowIndex},manager|user_dates_in_project_range:${rowIndex},manager,end`}
                stateField={`element.managers[${rowIndex}]`}
                insideTable
                showLabel={false}
                showIcon
                //minDate={minDate}
                //maxDate={maxDate}
                onAfterStateChange={() => this.fetchUserStatisticAndHandleError(manager, false)}

            />
        )
    }

    projectManagerTypeTemplate(rowData, props) {
        const { rowIndex } = props;
        const manager = rowData;
        return (
            <InputDropdownComponent
                id={`managerRoleType${rowIndex}`}
                name="roleType"
                label={t('project.details.leaderRole')}
                value={manager.roleType}
                stateField={`element.managers[${rowIndex}]`}
                showLabel={false}
                options={this.state.leaderRoles}
                optionLabel='label'
                onChange={this.handleChange}
                insideTable
                viewMode={this.props.viewMode}
                validator={this.validator}
                validators='required'
                showClear
            />
        )
    }

    projectManagerStatisticTemplate(rowData, props) {
        const { rowIndex } = props;
        const manager = rowData;


        const loading = manager ? manager.loadingStats : false;
        const render = manager ? manager.renderStats : false;
        return (
            <EmployeeProjectPlaningStatistic
                loading={loading}
                render={render}
                stats={manager?.stats}
                user={manager?.employee}
                showDetails={() => {
                    this.fetchUserStatistic(manager, false)
                        .then(() => {
                            this.setState({
                                visibleEmployeeStatistic: true,
                                selectedEmployee: manager?.employee,
                                selectedEmployeeStats: manager?.stats,
                                selectedEmployeeDateStart: manager?.dateStart,
                                selectedEmployeeDateEnd: manager?.dateEnd
                            })
                        })
                        .catch(err => this.showErrorMessage(err))
                }
                }
            />
        );
    }

    projectManagerActionsTemplate(rowData, props) {
        const { rowIndex } = props;
        const manager = rowData;
        return (
            <div className="col-md-1 actions">
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={(e) => {
                        let managers = this.state.element.managers.filter(m => m != manager);
                        this.setState((prevState) => ({
                            element: {
                                ...prevState.element,
                                managers,
                            },
                        }));
                    }}
                    variant='blue'
                    className='edit-blue-link'
                    key={'delete-button'}
                    rendered={this.props.viewMode != 'VIEW'}
                />
            </div>
        )
    }


    //PRACOWNICY END


    // AKTYWNOSCI
    handleAddNewProjectActivity() {
        const activities = this.state.element.activities;
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                activities: activities.concat({}),
            },
        }));
    }

    handleAddNewProjectTimeReportingActivity() {
        const activities = this.state.element.activitiesForTimeReporting?.length > 0 ? this.state.element.activitiesForTimeReporting.concat({}): [{}] ;
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                activitiesForTimeReporting: activities,
            },
        }));
    }

    projectActivityActionsTemplate(rowData) {
        return (
            <span>
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={(e) => {
                        let activities = this.state.element.activities.filter(pa => pa != rowData);
                        this.setState((prevState) => ({
                            element: {
                                ...prevState.element,
                                activities,
                            },
                        }));
                    }}
                    variant='blue'
                    className='edit-blue-link'
                    key={'delete-button'}
                />
            </span>
        );

    }
    projectActivityTimeReportingActionsTemplate(rowData) {
        return (
            <span>
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={(e) => {
                        let activitiesForTimeReporting = this.state.element.activitiesForTimeReporting.filter(pa => pa != rowData);
                        this.setState((prevState) => ({
                            element: {
                                ...prevState.element,
                                activitiesForTimeReporting,
                            },
                        }));
                    }}
                    variant='blue'
                    className='edit-blue-link'
                    key={'delete-button-time-reporting-activities'}
                />
            </span>
        );

    }

    projectActivityPriceTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <div style={{ minWidth: '150px' }}>
                <InputNumberComponent
                    id={`activityPrice${rowIndex}`}
                    name="price"
                    label={t('project.details.activityPricePerH')}
                    value={rowData.price}
                    stateField={`element.activities[${rowIndex}]`}
                    showLabel={false}
                    onChange={this.handleChange}
                    insideTable
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators={`required`}
                    mode="currency"
                    currency="PLN"
                    locale="pl-PL"
                />

            </div>

        );
    }

    selectedItemTemplate = (option) => {
        if (option != null) {
            return (
                <div className='p-multiselect-token' style={{ background: option.color.value }}>
                    <div className="p-multiselect-token-label" >
                        {option.name}
                    </div>
                    <div className="p-multiselect-token-icon pi pi-times-circle" onClick={(el) => {
                        const categories = this.state.element.categories.filter(c => c.id !== option.id);
                        this.setState((prevState) => ({
                            element: {
                                ...prevState.element,
                                categories: categories
                            }
                        }));
                    }
                    }>
                    </div>
                </div>
            );
        }
        return;
    };
    projectActivityActivityTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
         return (
            <div style={{ minWidth: '250px' }}>
                <InputDropdownComponent
                    id={`activity${rowIndex}`}
                    name="activity"
                    label={t('project.details.activityName')}
                    value={rowData.activity}
                    dataKey='id'
                    stateField={`element.activities[${rowIndex}]`}
                    showLabel={false}
                    options={this.state.activities}
                    optionLabel='name'
                    onChange={this.handleChange}
                    insideTable
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators={`required|not_duplicate_activities:${rowIndex}|incorrect_price_activities:${rowIndex}`}
                    showClear
                />
            </div>
        )
    }

    projectActivityForTimeReportingActivityTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <div style={{ minWidth: '250px' }}>
                <InputDropdownComponent
                    id={`activity${rowIndex}`}
                    name="activity"
                    label={t('project.details.activityName')}
                    value={rowData.activity}
                    dataKey='id'
                    stateField={`element.activitiesForTimeReporting[${rowIndex}]`}
                    showLabel={false}
                    options={this.state.activitiesForTimeReporting}
                    optionLabel='name'
                    onChange={this.handleChange}
                    insideTable
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators={`required|not_duplicate_activities_time_report:${rowIndex}`}
                    showClear
                />
            </div>
        )
    }


    inputColorComponent(categories) {
        return (
            (categories && categories.length >= 1) ? (
                <>
                    {categories.map(category => {
                        return <IconColorComponent icon={category.icon.value} color={category.color.value} tootltipText={category.name} />
                    })}
                </>
            ) : null)
    }


    // AKTYWNOSCI END
}


ProjectDetailsContainer.defaultProps = {
    backUrl: '/#/project-list',
    backDashboardUrl: '/#/project-dashboard',
    cancelUrl: '/#/project/details',
    editUrl: '/#/project/edit',
};

ProjectDetailsContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
};

export default withRouter(withTranslation()(ProjectDetailsContainer));

